import React from "react";
import ESPServiceRequestGrid from "../../components/EServicePartnerServiceRequests/ESPServiceRequestGrid";
import ESPNavbar from "./ESPNavbar";
import { useState } from "react";
import api from "../../utils/api";
import close_modal from '../../assets/ic_close_wh.svg'
import { Button } from "../../common/Button/Button";
import { getUser } from "../../utils/localStorage";
import { useEffect } from "react";
import { useLayoutEffect } from "react";
import ConfirmationModalSmall from "../../components/ServicePackaging/ConfirmationModalSmall";
import { ControlledInput } from "../../common/Input/Input";
import { toast } from "react-toastify";
import find from "lodash/find";
import Spinner from "../../common/Spinner/Spinner";
import { getESPUser } from "../../utils/localStorage";
// import { getUser } from "../../utils/localStorage";
import { storeESPSendSMSDetails } from "../../utils/localStorage";
import { getESPSendSMSDetails } from "../../utils/localStorage";
import { useHistory } from "react-router-dom";
import ESPReportsModal from "../../components/EServicePartnerServiceRequests/ESPReportsModal";
import { SELECTED_SIDE_BAR_ITEM_KEY } from "../../common/SidebarContent/SidebarContent";
import DePrenuerListingDetailsModal from "../../components/EServicePartnerServiceRequests/DePrenuerListingDetailsModal.jsx";
import EditDeprenuerListingDetailsModal from "../../components/EServicePartnerServiceRequests/EditDeprenuerListingDetailsModal";
import MarkVerifiedBusinessModel from "../../components/EServicePartnerServiceRequests/MarkVerifiedBusinessModel";
import ESPCustomerFeedback from "../../components/EServicePartnerServiceRequests/ESPCustomerFeedback.jsx"
import CustomerFeedbackContainer from "./CustomerFeedbackContainer";
import Checkbox from "../../common/Checkbox/Checkbox";
import ReactDatePicker from "react-datepicker";
import Select from "react-select";
import moment from "moment";
import RefundModal from "../../components/ServiceRequests/Facilitator/RefundModal";
import Modal from "react-modal";
import ModalContent from "../../common/Modal/ModalContent";

export default function EServicePartnerServiceRequest(props) {
    const history = useHistory();
    if (history.location.pathname.includes("/home/spled-service-requests")) {
        localStorage.setItem(SELECTED_SIDE_BAR_ITEM_KEY, "/home/spled-service-requests");
    }
    else {
        localStorage.setItem(SELECTED_SIDE_BAR_ITEM_KEY, "/service_partner/service-requests");
    }

    const [confirmationChecked, setConfirmationChecked] = useState(false)

    const [oppTypeNameList, setOppTypeNameList] = useState()
    const [selectedOppType, setSelectedOppType] = useState(null)

    const [oppTitleNameList, setOppTitleNameList] = useState([])
    const [selectedOppTitle, setSelectedOppTitle] = useState([])

    const [jpmcEligibleOption, setJpmcEligibleOptions] = useState([
        {
            value: 'Yes',
            label: 'Yes'
        },
        {
            value: 'No',
            label: 'No'
        }
    ])

    const [selectedJpmcEligible, setSelectedJpmcEligible] = useState([])

    const onJpmcEligileOptionChange = (option) => {
        setSelectedJpmcEligible(option)
    }

    const [businessSectorList, setBusinessSectorList] = useState([])
    const [selectedBusinessSector, setSelectedBusinessSector] = useState([])

    const [businessCityList, setBusinessCityList] = useState([])
    const [selectedBusinessCity, setSelectedBusinessCity] = useState([])

    const [displayRecordCount, setDisplayRecordCount] = useState({ displayCount: true, count: 0 })
    const [noShowOption, setNoShowOption] = useState([
        {
            value: 'No Show',
            label: 'Yes'
        },
        {
            value: 'No',
            label: 'No'
        }
    ])
    const [selectedNoShow, setSelectedNoShow] = useState([]);
    const [selectedNoShowEligible, setSelectedNoShowEligible] = useState(false);

    const onNoShowChange = (option) => {
        console.log('option', option)
        setSelectedNoShow(option)
    }


    const onOppTypeChange = (option) => {
        setSelectedOppType(option)
        getOppTitleNames(option)
    }

    // const onOppTitleChange = (option) => {
    //     setSelectedOppTitle(option)
    // }

    const getOppTitleNames = (ele) => {
        // let filterParameters = {}

        // if(selectedOppType !== null) {
        //     filterParameters.OpportunityType = selectedOppType.value
        // }
        if (ele) {
            const { tempOppTitleNames } = api.oppTitleListApi({
                OpportunityType: ele.value
            })
                .then(({ data }) => {
                    const formattedData = data.results.map((ele) => ({
                        value: ele.ResourceName,
                        label: ele.ResourceName
                    }))
                    setOppTitleNameList(formattedData)
                })
        } else {
            setOppTitleNameList([])
            setSelectedOppTitle([])
        }

    }

    const toggleAllOppTitle = () => {
        if (selectedOppTitle.length != oppTitleNameList.length && selectedOppTitle.length != (oppTitleNameList.length + 1)) {
            let temp = []

            if (selectedOppTitle.includes({ label: "All", value: "*" })) {
                temp = selectedOppTitle
            } else {
                temp = [{ label: "All", value: '*' }]
            }

            let tempSR = oppTitleNameList.map((e) => {
                if (!temp.includes(e)) {
                    temp = temp.concat(e)
                }
                return e
            })
            setOppTitleNameList(tempSR)
            setSelectedOppTitle(temp)
            //   getTagsDropdown(processFilters(temp))
        } else {
            setSelectedOppTitle([])
            //   getTagsDropdown(null)
        }
    }

    const onOppTitleChange = (options) => {
        const isAllSelected = options.some((opt) => opt.value === "*");
        if (isAllSelected) {
            setSelectedOppTitle([{ value: "*", label: "All" }]);
            // getTagsDropdown(processFilters(options))
        } else {
            setSelectedOppTitle(options.filter((opt) => opt.value !== "*"));
            // getTagsDropdown(processFilters(options))
        }
    }

    const toggleAllSector = () => {
        if (selectedBusinessSector.length != businessSectorList.length && selectedBusinessSector.length != (businessSectorList.length + 1)) {
            let temp = []

            if (selectedBusinessSector.includes({ label: "All", value: "*" })) {
                temp = selectedBusinessSector
            } else {
                temp = [{ label: "All", value: '*' }]
            }

            let tempSR = businessSectorList.map((e) => {
                if (!temp.includes(e)) {
                    temp = temp.concat(e)
                }
                return e
            })
            setBusinessSectorList(tempSR)
            setSelectedBusinessSector(temp)
            //   getTagsDropdown(processFilters(temp))
        } else {
            setSelectedBusinessSector([])
            //   getTagsDropdown(null)
        }

    }

    const onBusinessSectorChange = (options) => {
        // setSelectedBusinessSector(option)
        // getTagsDropdown(option)

        const isAllSelected = options.some((opt) => opt.value === "*");
        if (isAllSelected) {
            setSelectedBusinessSector([{ value: "*", label: "All" }]);
            // getTagsDropdown(processFilters(options))
        } else {
            setSelectedBusinessSector(options.filter((opt) => opt.value !== "*"));
            // getTagsDropdown(processFilters(options))
        }
    }

    const onBusinessCityChange = (options) => {
        // setSelectedBusinessCity(option)

        const isAllSelected = options.some((opt) => opt.value === "*");
        if (isAllSelected) {
            setSelectedBusinessCity([{ value: "*", label: "All" }]);
        } else {
            setSelectedBusinessCity(options.filter((opt) => opt.value !== "*"));
        }
    }

    const toggleAllBusinessCity = () => {
        if (selectedBusinessCity.length != businessCityList.length && selectedBusinessCity.length != (businessCityList.length + 1)) {
            let temp = []

            if (selectedBusinessCity.includes({ label: "All", value: "*" })) {
                temp = selectedBusinessCity
            } else {
                temp = [{ label: "All", value: '*' }]
            }

            let tempSR = businessCityList.map((e) => {
                if (!temp.includes(e)) {
                    temp = temp.concat(e)
                }
                return e
            })
            setBusinessCityList(tempSR)
            setSelectedBusinessCity(temp)
        } else {
            setSelectedBusinessCity([])
        }

    }

    useEffect(() => {
        const { tempOppTypeServiceNames } = api.oppTypeListApi()
            .then(({ data }) => {
                const formattedData = data.results.map((ele) => ({
                    value: ele.sServiceCode,
                    label: ele.sServiceName
                }))
                setOppTypeNameList(formattedData)
            })

        const { tempBusinessSectorListApi } = api.businessSectorListApi()
            .then(({ data }) => {
                console.log("Business Sector", data)
                const formattedData = data.data
                    .filter(ele => ele.sBusinessSector !== null)
                    .map((ele) => ({
                        value: ele.sBusinessSector,
                        label: ele.sBusinessSector
                    }))
                setBusinessSectorList(formattedData)
            })

        const { tempBusinessCityListApi } = api.businessCityListApi()
            .then(({ data }) => {
                const formatttedData = data.data
                    .map((ele) => ({
                        value: ele.sBusinessCity,
                        label: ele.sBusinessCity
                    }))
                setBusinessCityList(formatttedData)
            })
    }, [])

    let MainStatus = [
        {
            checked: false,
            label: "Requested",
            id: "Requested",
            code: "Requested",
        },
        {
            checked: false,
            label: "Eligible",
            id: "Eligible",
            code: "Eligible",
        },
        {
            checked: false,
            label: "Quotation Sent",
            id: "Quotation Sent",
            code: "Quotation Sent",
        },
        {
            checked: false,
            label: "Willing to Pay",
            id: "Willing to Pay",
            code: "Willing to Pay",
        },
        {
            checked: false,
            label: "Payment Received",
            id: "Payment Received",
            code: "Payment Received",
        },
        {
            checked: false,
            label: "Awaiting for information/Documents",
            id: "Awaiting for information/Documents",
            code: "Awaiting for information/Documents",
        },
        {
            checked: false,
            label: "Service Delivery Started",
            id: "Service Delivery Started",
            code: "Service Delivery Started",
        },
        {
            checked: false,
            label: "Service deliverables ready",
            id: "Service deliverables ready",
            code: "Service deliverables ready",
        },
        {
            checked: false,
            label: "Full Payment Requested",
            id: "Full Payment Requested",
            code: "Full Payment Requested",
        },
        {
            checked: false,
            label: "Full Payment Received",
            id: "Full Payment Received",
            code: "Full Payment Received",
        },
        {
            checked: false,
            label: "Delivered",
            id: "Delivered",
            code: "Delivered",
        },
        {
            checked: false,
            label: "Cancelled",
            id: "Cancelled",
            code: "Cancelled",
        },
        {
            checked: false,
            label: "Refunded",
            id: "Refunded",
            code: "Refunded",
        },
    ]


    const getSelectedItem = (Options, value) => {
        if (!Options) return;
        const found = find(Options, {
            value: value,
        });
        if (found) {
            return found;
        }
        return;
    };

    var status = [];
    var statusArray = MainStatus;
    var ServiceNameListForFilter = [];
    var ServiceStatusListForFilter = [];
    var PackageNameListForFilter = props.location.PackageNameListForFilter || null;
    var sfromDate = props.location.fromDate || "";
    var stoDate = props.location.toDate || "";
    var scurrentActiveTab = "Service Requests";
    var sresponseType = '';
    var sFfromDate = props.location.FfromDate || "";
    var sFtoDate = props.location.FtoDate || "";
    var sRequestWithinTAT = "";

    //For Admin

    var sSelectedExternalServicePartner = props.location.selectedExternalServicePartner || null;

    if (props.location.sStatus) {
        status = status.concat(props.location.sStatus);
        let tempStatus = MainStatus.map((x) => {
            if (x.id == status) {
                x.checked = true;
            }
            return x;
        });
        statusArray = tempStatus;

    }

    if (props.location.ServiceNameListForFilter) {
        if (!ServiceNameListForFilter.includes(props.location.ServiceNameListForFilter)) {
            ServiceNameListForFilter = ServiceNameListForFilter.concat(props.location.ServiceNameListForFilter);
        }
    }

    if (props.location.sStatus) {
        if (!ServiceStatusListForFilter.includes({
            label: props.location.sStatus,
            value: props.location.sStatus,
            id: props.location.sStatus,
        })) {
            ServiceStatusListForFilter = ServiceStatusListForFilter.concat({
                label: props.location.sStatus,
                value: props.location.sStatus,
                id: props.location.sStatus,
            });
        }
    }

    if (props.location.currentActiveTab) {
        scurrentActiveTab = props.location.currentActiveTab;
    }

    if (props.location.responseType) {
        sresponseType = props.location.responseType;
    }

    if (props.location.requestWithinTAT) {
        sRequestWithinTAT = props.location.requestWithinTAT;
    }

    if (props.location.signedUpRequests) {
        if (!ServiceStatusListForFilter.includes({
            label: "Payment Received",
            value: "Payment Received",
            id: "Payment Received",
        })) {
            ServiceStatusListForFilter = ServiceStatusListForFilter.concat({
                label: "Payment Received",
                value: "Payment Received",
                id: "Payment Received",
            });
        }

        if (!ServiceStatusListForFilter.includes({
            label: "Delivered",
            value: "Delivered",
            id: "Delivered",
        })) {
            ServiceStatusListForFilter = ServiceStatusListForFilter.concat({
                label: "Delivered",
                value: "Delivered",
                id: "Delivered",
            });
        }
    }

    // Zero Price Confirmation Modal

    const [confirmationModal, setConfirmationModal] = useState(false)

    const openConfirmationModalisTrue = () => {
        setConfirmationModal(true)
    }

    const openConfirmationModalisFalse = () => {
        setConfirmationModal(false)
    }

    // Feedback states
    const [FfromDate, setFfromDate] = useState(sFfromDate);
    const [FtoDate, setFtoDate] = useState(sFtoDate);
    const [responseType, setResponseType] = useState(sresponseType);
    const [currentActiveTab, setCurrentActiveTab] = useState(scurrentActiveTab);

    const [MainExterServicePartnerList, setMainExterServicePartnerList] = useState([]);
    const [MainServiceRequestsNameList, setMainServiceRequestsNameList] = useState([]);
    const [activePage, setActivePage] = useState("");


    const [requestWithinTAT, setRequestWithinTAT] = useState(sRequestWithinTAT);
    const [unReadFeedbackCount, setUnReadFeedbackCount] = useState(0);
    const [serviceStatusList, setServiceStatusList] = useState(statusArray);
    const [selectedServiceStatus, setSelectedServiceStatus] = useState(status);
    const [fromDate, setfromDate] = useState(sfromDate);
    const [toDate, settoDate] = useState(stoDate);
    const [selectedServiceNameListForFilter, setSelectedServiceNameListForFilter] = useState(ServiceNameListForFilter);
    const [selectedPackageNameListForFilter, setSelectedPackageNameListForFilter] = useState(PackageNameListForFilter);
    const [selectedServiceStatusListForFilter, setSelectedServiceStatusListForFilter] = useState(ServiceStatusListForFilter);

    const [ExpandedChange, setExpandedChange] = useState({});

    /*Common states */

    const [activeFocus, setactiveFocus] = useState("");
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [statusList, setStatusList] = useState([
        "Requested",
        "Eligible",
        "Prepared",
        "Partial/ Full Payment Pending",
        "Payment Received",
        "Ready For Progression",
        "Payment Confirmed By Partner",
        "Service Delivery Started",
        "Service deliverables ready",
        "Delivered",
        "Cancelled",
    ]);


    let ServiceStatus = [
        "Requested",
        "Eligible",
        "Quotation Sent",
        "Prepared",
        "Partial/ Full Payment Pending",
        "Payment Received",
        "Ready For Progression",
        "Payment Confirmed By Partner",
        "Awaiting for information/Documents",
        "Service Delivery Started",
        "Service deliverables ready",
        "Full Payment Requested",
        "Full Payment Received",
        "Delivered",
        "Cancelled",
    ]

    const [masterServiceRequestStates, setMasterServiceRequestStates] = useState([]);
    const [cancellationReasonDropdownOptions, setCancellationReasonDropdownOptions,] = useState([]);

    const [editingServiceRequestList, setEditingServiceRequestList] = useState([]);
    const [selectedServiceForEdit, setSelectedServiceForEdit] = useState();
    const [selectedSecondServiceForEdit, setSelectedSecondServiceForEdit] = useState();
    const toggleConfirmationModal = () => { setShowConfirmationModal(!showConfirmationModal); };
    const confirmBtnClick = () => {
        openConfirmationModalisFalse()
        let payload = {
            nResourceInstanceId: selectedServiceForEdit.nResourceInstanceId,
            fAmountFull: 0
        }
        setIsLoading(true)
        api.updatePriceApi(payload)
            .then(({ data }) => {
                toast("Service Moved to SPM", {
                    type: toast.TYPE.SUCCESS,
                });
                setIsLoading(false)
                getExternalPartnerServices(tableInstance, false)
            })
        console.log("Payload1", payload)

        // ChangeServiceStateLPM(selectedServiceForEdit);
        // openConfirmationModalisFalse()
    }
    const [customerNeedAnyOtherServiceOptions, setcustomerNeedAnyOtherServiceOptions] = useState([
        {
            value: "0",
            label: "Needs current requested service along with an additional service",
        },
        {
            value: "1",
            label: "Needs the additional service first and then the current requested service",
        },
        {
            value: "2",
            label: "Does not need the current requested service. Only the additional service is required",
        },
    ]);

    /*Need to talk to SP*/
    const [needToTalkToSPOptions, setneedToTalkToSPOptions] = useState([
        {
            value: true,
            label: "Yes",
        },
        {
            value: false,
            label: "No",
        },
    ]);
    /*End*/

    const [callStatusOptions, setCallStatusOptions] = useState([
        {
            value: "0",
            label: "No",
        },
        {
            value: "1",
            label: "Yes",
        },
    ]);

    const [showTable, toggleShowTable] = React.useState(true);
    const [pages, setPages] = useState(0);
    const [currentPage, setcurrentPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [tableInstance, setTableInstance] = useState(null);
    const [ESPName, setESPName] = useState("");
    const [pageSizeOptions, setpageSizeOptions] = useState([
        {
            value: "10",
            label: "10 Rows",
        },
        {
            value: "20",
            label: "20 Rows",
        },
        {
            value: "30",
            label: "30 Rows",
        },
    ]);
    const [selectedPageSizeOption, setSelectedPageSizeOption] = useState({
        value: "10",
        label: "10",
    });

    const [showReportsModal, setShowReportsModal] = useState(false);
    const toggleReportsModal = () => { setShowReportsModal(!showReportsModal); };
    const [ASPfromDate, setASPfromDate] = useState("");
    const [ASPtoDate, setASPtoDate] = useState("");
    const [SRFfromDate, setSRFfromDate] = useState("");
    const [SRFtoDate, setSRFtoDate] = useState("");
    const [isLoadingReports, setIsLoadingReports] = useState(false);

    /*Service Filter logic change states*/
    const [callStatusOptionsForFilter, setCallStatusOptionsForFilter] = useState([
        {
            value: "all",
            label: "All",
        },
        {
            value: "-1",
            label: "Blank",
        },
        {
            value: "0",
            label: "No",
        },
        {
            value: "1",
            label: "Yes",
        },
    ]);
    const [selectedCallStatusOptionForFilter, setselectedCallStatusOptionForFilter] = useState(null/*{
        value: "all",
        label: "All",
    }*/);
    const [serviceNameListForFilter, setServiceNameListForFilter] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [
        requestedaCallBackOptions,
        setrequestedaCallBackOptions,
    ] = useState([
        {
            value: "all",
            label: "All",
        },
        {
            value: "yes",
            label: "Yes",
        },
        {
            value: "no",
            label: "No",
        },
    ]);
    const [
        selectedRequestedaCallBackOption,
        setSelectedRequestedaCallBackOption,
    ] = useState(null/*{
		value: "all",
		label: "All",
	}*/);

    const [
        selectedNeedToTalkToSPOption,
        setSelectedNeedToTalkToSPOption,
    ] = useState(null/*{
		value: "all",
		label: "All",
	}*/);
    const [
        requestedByOptions,
        setrequestedByOptions,
    ] = useState([
        {
            value: "all",
            label: "All",
        },
        {
            value: "user",
            label: "User",
        },
        {
            value: "ehh",
            label: "EHH",
        },
    ]);
    const [
        selectedRequestedByOption,
        setSelectedRequestedByOption,
    ] = useState(null/*{
		value: "all",
		label: "All",
	}*/);

    const [packageNameListForFilter, setPackageNameListForFilter] = useState([]);
    const [serviceStatusNameListForFilter, setServiceStatusNameListForFilter] = useState([]);

    const [oppTypeNameListForFilter, setOppTypeNameListForFilter] = useState([])
    /*Service Filter logic change states end*/

    const [
        selectedcustomerNeedAnyOtherServiceOption,
        setSelectedcustomerNeedAnyOtherServiceOption,
    ] = useState(null);

    const [externalServicePartnerList, setExternalServicePartnerList] = useState([]);
    const [selectedExternalServicePartner, setselectedExternalServicePartner] = useState(null);
    const [selectedExternalServicePartnerOrganization, setselectedExternalServicePartnerOrganization] = useState("");

    const [
        custsNotesHHCursorPosition,
        setcustsNotesHHCursorPosition,
    ] = useState({
        selectionStart: 0,
        selectionEnd: 0,
    });

    /*dePreneur details modal callbacks */
    const [showdePreneurDetailsModal, setShowdePreneurDetailslModal] = useState(false);
    const toggledePreneurDetailsModal = () => {
        setShowdePreneurDetailslModal(!showdePreneurDetailsModal);
    };
    const handleViewdePreneurDetailsModal = (original) => {
        if (original && original.depreneur_service_data) {
            setselectedServiceRequestBusinessDetails({ sBusinessName: original.depreneur_service_data.sBusinessName, sImageUrl: original.depreneur_service_data.sImageUrl, sBusinessDescription: original.depreneur_service_data.sBusinessDescription, resource_instance_id: original.nResourceInstanceId, is_business_verified: original.depreneur_service_data.is_business_verified, custrefSRState: original.custrefSRState, sFirstName: original.depreneur_service_data.first_name, sLastName: original.depreneur_service_data.last_name, sBusinessSector: original.depreneur_service_data.sBusinessSector, pincode: original.depreneur_service_data.pincode })
            setselectedServiceRequestBusinessDetailsForEdit({ sBusinessName: original.depreneur_service_data.sBusinessName, sImageUrl: original.depreneur_service_data.sImageUrl, sBusinessDescription: original.depreneur_service_data.sBusinessDescription, resource_instance_id: original.nResourceInstanceId, is_business_verified: original.depreneur_service_data.is_business_verified, custrefSRState: original.custrefSRState, sBusinessSector: original.depreneur_service_data.sBusinessSector, pincode: original.depreneur_service_data.pincode })
        }
        else {
            setselectedServiceRequestBusinessDetails("")
        }
        toggledePreneurDetailsModal();
    };
    /*End */

    const [showdePrenuerListringDetailsModal, setShowdePrenuerListringDetailsModal] = useState(false);
    const onToggledePrenuerListingModal = (original) => {
        if (original && original.depreneur_service_data) {
            setselectedServiceRequestBusinessDetails({ sBusinessName: original.depreneur_service_data.sBusinessName, sImageUrl: original.depreneur_service_data.sImageUrl, sBusinessDescription: original.depreneur_service_data.sBusinessDescription, resource_instance_id: original.nResourceInstanceId, is_business_verified: original.depreneur_service_data.is_business_verified, custrefSRState: original.custrefSRState, sFirstName: original.depreneur_service_data.first_name, sLastName: original.depreneur_service_data.last_name, sBusinessSector: original.depreneur_service_data.sBusinessSector, pincode: original.depreneur_service_data.pincode })
        }
        else {
            setselectedServiceRequestBusinessDetails("");
            setselectedServiceRequestBusinessDetailsForEdit("");
        }

        setShowdePrenuerListringDetailsModal(!showdePrenuerListringDetailsModal);
    };

    const [showEditdePrenuerListringDetailsModal, setShowEditdePrenuerListringDetailsModal] = useState(false);
    const onEditdePrenuerListringDetails = (original) => {
        if (original && original.depreneur_service_data) {
            setselectedServiceRequestBusinessDetails({ sBusinessName: original.depreneur_service_data.sBusinessName, sImageUrl: original.depreneur_service_data.sImageUrl, sBusinessDescription: original.depreneur_service_data.sBusinessDescription, resource_instance_id: original.nResourceInstanceId, is_business_verified: original.depreneur_service_data.is_business_verified, custrefSRState: original.custrefSRState, sBusinessSector: original.depreneur_service_data.sBusinessSector, pincode: original.depreneur_service_data.pincode })
        }
        else {
            setselectedServiceRequestBusinessDetails("")
        }
        setShowEditdePrenuerListringDetailsModal(!showEditdePrenuerListringDetailsModal);
    };
    const [selectedServiceRequestBusinessDetails, setselectedServiceRequestBusinessDetails] = useState("");
    const [selectedServiceRequestBusinessDetailsForEdit, setselectedServiceRequestBusinessDetailsForEdit] = useState("");

    const [showVerifyBusinessModal, setShowVerifyBusinessModal] = useState(false);
    const onToggleVerifyBusinessModal = (original) => {
        if (original && original.depreneur_service_data) {
            setselectedServiceRequestBusinessDetails({ sBusinessName: original.depreneur_service_data.sBusinessName, sImageUrl: original.depreneur_service_data.sImageUrl, sBusinessDescription: original.depreneur_service_data.sBusinessDescription, resource_instance_id: original.nResourceInstanceId, is_business_verified: original.depreneur_service_data.is_business_verified, custrefSRState: original.custrefSRState, sBusinessSector: original.depreneur_service_data.sBusinessSector, pincode: original.depreneur_service_data.pincode })
        }
        else {
            setselectedServiceRequestBusinessDetails("")
        }

        setShowVerifyBusinessModal(!showVerifyBusinessModal);
    };

    /*Filter modal callbacks */
    const [showFilterModal, setShowFilterModal] = useState(false);
    const toggleFilterModal = () => {
        setShowFilterModal(!showFilterModal);
    };
    const handleViewFilterModal = (original) => {
        toggleFilterModal();
    };
    /*End */

    /*Follow Up */
    const [FollowUpDate, setFollowUpDate] = useState("");
    const [FollowUpCount, setFollowUpCount] = useState(0);
    const [AllFollowUpCount, setAllFollowUpCount] = useState(0);
    const [isFollowUpCompleted, setisFollowUpCompleted] = useState(false);
    const [isFollowUpOpen, setisFollowUpOpen] = useState(false);
    const handleFollowUpClick = () => {
        setisFollowUpOpen(!isFollowUpOpen);
    };
    /*End */

    /*Send SMS */
    const [SendSMSConfirmationMessage, setSendSMSConfirmationMessage] = useState("");
    const [showSendSMSConfirmationModal, setShowSendSMSConfirmationModal] = useState(false);
    const [selectedServiceForSendSMS, setSelectedServiceForSendSMS] = useState();
    const toggleSendSMSConfirmationModal = () => { setShowSendSMSConfirmationModal(!showSendSMSConfirmationModal); };
    /*End */

    const onFollowUpsCountClick = (ev) => {
        localStorage.setItem(SELECTED_SIDE_BAR_ITEM_KEY, "/service_partner/follow-ups");
        history.push({
            pathname: "/service_partner/follow-ups"
        });
    }



    useEffect(() => {
        if (history.location.pathname.includes("/home/spled-service-requests")) {
            const user = getUser();
            const hasSPReportRole = user.role.includes(9);
            if (hasSPReportRole) {
                setActivePage("SPLedServiceRequests");
                api.getAllExternalServicePartners()
                    .then((d) => {
                        var exterServicePartners = [];
                        d.data.map((f) => {
                            if (f.sServicePartnerEmail) {
                                exterServicePartners.push(f);
                            }
                        });
                        setMainExterServicePartnerList(exterServicePartners);
                    });

                api.getAllPackageCatalogues().then(({ data }) => {
                    const packageNamesForFilter = [];
                    Object.keys(data).map((idx) => {
                        if (data[idx].sPackageOfferStatus === 'Published') {
                            packageNamesForFilter.push({
                                label: data[idx].sPackageOfferTitle,
                                value: data[idx].id,
                            });
                        }
                    });
                    setPackageNameListForFilter(packageNamesForFilter);
                });

                api.oppTypeListApi().then(({ data }) => {
                    console.log("Opp Type", data)
                    const oppTypeNamesForFilter = [];
                    Object.keys(data.results).map((idx) => {
                        oppTypeNamesForFilter.push({
                            label: data.results[idx].sServiceName,
                            value: data.results[idx].sServiceCode,
                        });
                    }
                    );
                    console.log(oppTypeNamesForFilter, "Opp")
                    setOppTypeNameListForFilter(oppTypeNamesForFilter)
                })

                api.getDisableFalseServiceRequestsNames({ bDisableService: false })
                    .then(({ data }) => {
                        setMainServiceRequestsNameList(data);
                    });

                const { temp } = api.getCancellationReasons().then(({ data }) => {
                    console.log("cancellationRason", data);
                    let temp1 = data.map((e) => {
                        return { value: e.sReason, label: e.sReason };
                    });
                    setCancellationReasonDropdownOptions(temp1);
                });

                const serviceStatusNameForFilter = [];
                MainStatus.map((x) => {
                    serviceStatusNameForFilter.push({
                        label: x.label,
                        value: x.code,
                        id: x.id,
                    });
                });

                setServiceStatusNameListForFilter(serviceStatusNameForFilter);
            }
            else {
                setActivePage("No_Access");
            }
        }
        else {
            if (!getESPUser()) {
                history.push("/service_partner/login");
            }
            else {
                setActivePage("SPLedServiceRequests");
                var user = getESPUser();
                setESPName(user.external_partner_details.sServicePartnerOrg ? user.external_partner_details.sServicePartnerOrg : user.external_partner_details.sName);

                var ESPServiceCodeList = [];
                if (user && user.external_partner_details && user.external_partner_details.sServiceCode_list) {

                    ESPServiceCodeList = user.external_partner_details.sServiceCode_list;
                }
                const { temp } = api.getCancellationReasons().then(({ data }) => {
                    console.log("cancellationRason", data);
                    let temp1 = data.map((e) => {
                        return { value: e.sReason, label: e.sReason };
                    });
                    setCancellationReasonDropdownOptions(temp1);
                });

                const serviceStatusNameForFilter = [];
                MainStatus.map((x) => {
                    serviceStatusNameForFilter.push({
                        label: x.label,
                        value: x.code,
                        id: x.id,
                    });
                });

                setServiceStatusNameListForFilter(serviceStatusNameForFilter);

                api.getAllPackageCatalogues().then(({ data }) => {
                    const packageNamesForFilter = [];
                    Object.keys(data).map((idx) => {
                        if (data[idx].sPackageOfferStatus === 'Published') {
                            packageNamesForFilter.push({
                                label: data[idx].sPackageOfferTitle,
                                value: data[idx].id,
                            });
                        }
                    });
                    setPackageNameListForFilter(packageNamesForFilter);
                });

                api.oppTypeListApi().then(({ data }) => {
                    console.log("Opp Type", data)
                    const oppTypeNamesForFilter = [];
                    Object.keys(data.results).map((idx) => {
                        oppTypeNamesForFilter.push({
                            label: data.results[idx].sServiceName,
                            value: data.results[idx].sServiceCode,
                        });
                    }
                    );
                    console.log(oppTypeNamesForFilter, "Opp")
                    setOppTypeNameListForFilter(oppTypeNamesForFilter)
                })

                api.getDisableFalseServiceRequestsNames({ bDisableService: false })
                    .then(({ data }) => {
                        const serviceReqNamesForFilter = Object.keys(data).map((idx) => {
                            return {
                                label: data[idx].sServiceName,
                                id: data[idx].id,
                                value: data[idx].sServiceCode,
                            };
                        });

                        let tempserviceReqNamesForFilter = [];
                        if (ESPServiceCodeList.length > 0) {
                            serviceReqNamesForFilter.map((e) => {
                                if (ESPServiceCodeList.includes(e.value)) {
                                    tempserviceReqNamesForFilter.push(e);
                                }
                            });
                        }
                        else {
                            tempserviceReqNamesForFilter = serviceReqNamesForFilter;
                        }
                        setServiceNameListForFilter(tempserviceReqNamesForFilter);
                    });

                // Get ESP Service Requests
                //getExternalPartnerServices();
            }
        }
    }, []);

    /*useEffect(() => {
        if (!getESPUser()) {
            history.push("/service_partner/login");
        }
        else
        {
            if(!showTable)
            {
                toggleShowTable(true);                
            }
            else
            {
                getExternalPartnerServices(tableInstance)
            }
        }
    }, [showTable]);*/

    useEffect(() => {
        if (history.location.pathname.includes("/service_partner/service-requests")) {
            if (!getESPUser()) {
                history.push("/service_partner/login");
            }
            else {
                let LocalSMSDetails = getESPSendSMSDetails();
                if (LocalSMSDetails) {
                    let UpdatedRecords = [];
                    LocalSMSDetails.map((item) => {
                        if (getMinutesBetweenDates(new Date(), new Date(item.AddedOn)) < 5) {
                            UpdatedRecords.push(item)
                        }
                    });
                    storeESPSendSMSDetails(UpdatedRecords);
                }
            }
        }

    }, []);

    //for admin
    useEffect(() => {
        if (history.location.pathname.includes("/home/spled-service-requests")) {
            let externalServicePartners = MainExterServicePartnerList.map((f) => {
                return {
                    value: f["sServicePartnerEmail"],
                    label: f["sName"] + (f["sServicePartnerOrg"] ? ("(" + f["sServicePartnerOrg"] + ")") : ""),
                };
            });
            setExternalServicePartnerList(externalServicePartners);
            if (sSelectedExternalServicePartner) {
                onExternalServicePartnerChange(sSelectedExternalServicePartner, ServiceNameListForFilter);
            }
            else {
                onExternalServicePartnerChange(externalServicePartners[0], ServiceNameListForFilter);
            }
        }


    }, [MainExterServicePartnerList, MainServiceRequestsNameList]);
    //end

    useEffect(() => {
        if (editingServiceRequestList.length > 0) {
            if (selectedServiceForEdit) {
                const found = find(editingServiceRequestList, {
                    nResourceInstanceId: selectedServiceForEdit.nResourceInstanceId,
                });

                if (found) {
                    let expandedRow = { [editingServiceRequestList.indexOf(found)]: true }
                    createStateDropdownForSelectedService(found);
                    setSelectedServiceForEdit(found);
                    setSelectedSecondServiceForEdit();
                    setExpandedChange(expandedRow);
                }
                else {
                    setSelectedServiceForEdit();
                    setSelectedSecondServiceForEdit();
                    setExpandedChange({});
                }
            }
            else {
                setSelectedServiceForEdit();
                setSelectedSecondServiceForEdit();
                //setExpandedChange({});
            }
        }
        else {
            setSelectedServiceForEdit();
            setSelectedSecondServiceForEdit();
            setExpandedChange({});
        }
    }, [editingServiceRequestList]);

    useEffect(() => {
        if (history.location.pathname.includes("/home/spled-service-requests")) {
            if (!getUser()) {
                history.push("/login");
            }
            else {
                const user = getUser();
                const hasSPReportRole = user.role.includes(9);
                if (hasSPReportRole) {
                    setActivePage("SPLedServiceRequests");
                    getExternalPartnerServices(tableInstance, true)
                }
                else {
                    setActivePage("No_Access");
                }
            }
        }
        else {
            if (!getESPUser()) {
                history.push("/service_partner/login");
            }
            else {
                getExternalPartnerServices(tableInstance, true)
            }
        }

    }, [selectedPageSizeOption]);


    const fetchServiceRequests = (instance, flag) => {
        if (history.location.pathname.includes("/home/spled-service-requests")) {
            if (!getUser()) {
                history.push("/login");
            }
            else {
                const user = getUser();
                const hasSPReportRole = user.role.includes(9);
                if (hasSPReportRole) {
                    setActivePage("SPLedServiceRequests");
                    getExternalPartnerServices(instance, flag);
                }
                else {
                    setActivePage("No_Access");
                }
            }
        }
        else {
            if (!getESPUser()) {
                history.push("/service_partner/login");
            }
            else {
                // if(confirmationChecked){
                //     getFilterDataExternalService(instance, flag)
                // } else {
                getExternalPartnerServices(instance, flag);
                // }

            }
        }

    };

    //For Admin
    useEffect(() => {
        if (selectedExternalServicePartner) {
            getExternalPartnerServices(tableInstance, true);
        }
    }, [selectedExternalServicePartner]);

    const onExternalServicePartnerChange = (option, ServiceNameListForFilter = []) => {
        var ESPServiceCodeList = [];
        var ExternalServicePartnerOrganization = "";
        MainExterServicePartnerList.map((f) => {
            if (f.sServicePartnerEmail === option.value) {
                ExternalServicePartnerOrganization = f.sServicePartnerOrg;
                ESPServiceCodeList = f.sServiceCode_list;
            }
        });

        const serviceReqNamesForFilter = MainServiceRequestsNameList.map((idx) => {
            return {
                label: idx.sServiceName,
                id: idx.id,
                value: idx.sServiceCode,
            };
        });

        let tempserviceReqNamesForFilter = [];
        if (ESPServiceCodeList.length > 0) {
            serviceReqNamesForFilter.map((e) => {
                if (ESPServiceCodeList.includes(e.value)) {
                    tempserviceReqNamesForFilter.push(e);
                }
            });
        }
        else {
            tempserviceReqNamesForFilter = serviceReqNamesForFilter;
        }

        let temp = [{ label: "All", value: "*" }];
        let tempSR = tempserviceReqNamesForFilter.map((e) => {
            if (!temp.includes(e)) {
                temp = temp.concat(e);
            }
            return e;
        });

        if (option) {
            let filterParameters = {};
            filterParameters.email = option.value;
            api.getAllPackageCatalogues(filterParameters).then(({ data }) => {
                const packageNamesForFilter = [];
                Object.keys(data).map((idx) => {
                    if (data[idx].sPackageOfferStatus === 'Published') {
                        packageNamesForFilter.push({
                            label: data[idx].sPackageOfferTitle,
                            value: data[idx].id,
                        });
                    }
                });
                setPackageNameListForFilter(packageNamesForFilter);
            });
        }
        setServiceNameListForFilter(tempserviceReqNamesForFilter);
        if (ServiceNameListForFilter) {
            setSelectedServiceNameListForFilter(ServiceNameListForFilter);
        }
        else {
            setSelectedServiceNameListForFilter(temp);
        }
        setselectedExternalServicePartnerOrganization(ExternalServicePartnerOrganization);
        setselectedExternalServicePartner(option);
        setSelectedPackageNameListForFilter(null);
        setExpandedChange({});
    }
    //End

    // For Follow up 
    useEffect(() => {
        setFollowUpDate("");
        setisFollowUpCompleted(false);
        setisFollowUpOpen(false);
    }, [ExpandedChange]);
    //End

    const getExternalPartnerServicesUpdate = () => {
        //let sortParams = null;
        //if (instance.state.sorted.length > 0) {
        //const { id, desc } = instance.state.sorted[0];
        //sortParams = { column: id, desc };
        //}

        let serviceRequestListtemp2 = [];
        selectedServiceNameListForFilter.map((e) => {
            if (e.value != "*") {
                serviceRequestListtemp2.push(e.value);
            }
        });
        const serviceRequestList = serviceRequestListtemp2;

        let servicestatusListtemp2 = [];
        selectedServiceStatusListForFilter.map((e) => {
            if (e.value != "*") {
                servicestatusListtemp2.push(e.value);
            }
        });
        const serviceStatusList = servicestatusListtemp2;

        let serviceStatusFilter = [];
        serviceStatusList.map((e) => {
            if (e === "Willing to Pay") {
                serviceStatusFilter.push("Ready For Progression:Partner");
                serviceStatusFilter.push("Partial/ Full Payment Pending");
            }
            else if (e === "Payment Received") {
                serviceStatusFilter.push("Payment Confirmed By Partner");
                serviceStatusFilter.push("Ready For Progression:deAsra");
            }
            else {
                serviceStatusFilter.push(e);
            }
        });
        const statusList = serviceStatusFilter;

        let filterParameters = {
            page_size: pageSize
            //...sortParams,
        };

        //let filterParameters = {};
        if (serviceRequestList.length) {
            filterParameters.service_codes = serviceRequestList;
        }
        if (statusList.length) {
            filterParameters.statusList = statusList;
        }

        if (selectedRequestedaCallBackOption && selectedRequestedaCallBackOption.value == 'yes') {
            filterParameters.bRequestedCallBack = true;
        }
        else if (selectedRequestedaCallBackOption && selectedRequestedaCallBackOption.value == 'no') {
            filterParameters.bRequestedCallBack = false;
        }

        if (selectedCallStatusOptionForFilter && selectedCallStatusOptionForFilter.value != 'all') {
            filterParameters.sCallStatus = selectedCallStatusOptionForFilter.value;
        }


        if (selectedofflinemeetoptionsForFilter && selectedofflinemeetoptionsForFilter.value != 'all') {
            filterParameters.bOfflineMeet = selectedofflinemeetoptionsForFilter.value;
        }



        // if(selectedofflinemeetoptionsForFilter&&selectedofflinemeetoptionsForFilter.value=='Opted')
        // {
        //     filterParameters.bOfflineMeet=true;
        // }
        // else if(selectedofflinemeetoptionsForFilter&&selectedofflinemeetoptionsForFilter.value=='Not Opted')
        // {
        //     filterParameters.bOfflineMeet=false;
        // }







        if (selectedNeedToTalkToSPOption && selectedNeedToTalkToSPOption.value == 'yes') {
            filterParameters.bNeedToTalkToSP = true;
        }
        else if (selectedNeedToTalkToSPOption && selectedNeedToTalkToSPOption.value == 'no') {
            filterParameters.bNeedToTalkToSP = false;
        }


        // if(selectedofflinemeetoptions&&selectedofflinemeetoptions.value=='Opted')
        // {
        //     filterParameters.bOfflineMeet=true;
        // }
        // else if(selectedofflinemeetoptions&&selectedofflinemeetoptions.value=='Not Opted')
        // {
        //     filterParameters.bOfflineMeet=false;
        // }


        if (selectedRequestedByOption && selectedRequestedByOption.value == 'ehh') {
            filterParameters.req_by = 'ehh';
        }
        else if (selectedRequestedByOption && selectedRequestedByOption.value == 'user') {
            filterParameters.req_by = 'user';
        }

        if (searchTerm) {
            filterParameters.search_value = searchTerm;
        }

        if (fromDate) {
            filterParameters.fromDate = fromDate;
        }

        if (toDate) {
            filterParameters.toDate = adjustedToDate(toDate);;
        }

        if (history.location.pathname.includes("/home/spled-service-requests") && selectedExternalServicePartner) {
            filterParameters.email = selectedExternalServicePartner.value;
        }

        if (selectedPackageNameListForFilter) {
            filterParameters.nPackageCatalogueId = selectedPackageNameListForFilter.value;
        }

        if (requestWithinTAT) {
            if (requestWithinTAT === "yes") {
                filterParameters.within_tat = "True";
            }
            else {
                filterParameters.within_tat = "False";
            }
        }

        setIsLoading(true);
        const { tempServices } = api.getExternalPartnerServices().then(({ data }) => {
            setIsLoading(false);
            if (data) {
                setPages(data.total_pages);
                setPageSize(pageSize);
                setUnReadFeedbackCount(data.unread_feedbacks);
                setFollowUpCount(data.todays_follow_up_count || 0);
                setAllFollowUpCount(data.all_follow_up_count || 0)
                let tempLPMServiceList = data.ServiceRequests.map((x) => {
                    x.custrefSRState = x.refSRState;
                    x.custsSRCancellationReason = x.sSRCancellationReason;
                    x.custssSRCancellationReasonOtherDescription = x.sSRCancellationReasonOtherDescription;
                    x.custsNotesHH = null;
                    x.custdtFollowupOn = null;
                    x.custsFollowupNotes = null;
                    x.serviceFrom = "LPM";
                    x.custOtherServiceInfo = x.sOtherServicesInfo;
                    x.custfGovtCharges = x.ext_sp_charges ? (x.ext_sp_charges.fGovtCharges) : (null);
                    x.custfAffiliateFees = x.ext_sp_charges ? (x.ext_sp_charges.fAffiliateFees) : (null);
                    x.custfProfessionalCharges = x.ext_sp_charges ? (x.ext_sp_charges.fProfessionalCharges) : (null);
                    x.custfTotalCharges = x.ext_sp_charges ? (x.ext_sp_charges.fTotalCharges) : (null);
                    x.custChargesid = x.ext_sp_charges ? (x.ext_sp_charges.id) : (null);
                    x.custsCallStatus = x.sCallStatus;
                    x.custsUpdateNoteForAllServicesInPackage = false;
                    x.custbNeedToTalkToSP = x.bNeedToTalkToSP;
                    x.custbOfflineMeet = x.bOfflineMeet;
                    return x;
                });

                let tempSPMerviceList = data.Services.map((x) => {
                    x.custrefSRState = x.refCurrentState.sServiceState;
                    x.custsSRCancellationReason = x.sServiceCancellationReason;
                    x.custssSRCancellationReasonOtherDescription = x.sServiceCancellationReasonOtherDescription;
                    x.custsNotesHH = null;
                    x.custdtFollowupOn = null;
                    x.custsFollowupNotes = null;
                    x.serviceFrom = "SPM";
                    x.OtherServiceInfo = null;
                    x.custOtherServiceInfo = x.sOtherServicesInfo;
                    x.custfGovtCharges = x.ext_sp_charges ? (x.ext_sp_charges.fGovtCharges) : (null);
                    x.custfAffiliateFees = x.ext_sp_charges ? (x.ext_sp_charges.fAffiliateFees) : (null);
                    x.custfProfessionalCharges = x.ext_sp_charges ? (x.ext_sp_charges.fProfessionalCharges) : (null);
                    x.custfTotalCharges = x.ext_sp_charges ? (x.ext_sp_charges.fTotalCharges) : (null);
                    x.custChargesid = x.ext_sp_charges ? (x.ext_sp_charges.id) : (null);
                    x.custsCallStatus = x.sCallStatus;
                    x.custsUpdateNoteForAllServicesInPackage = false;
                    x.custbNeedToTalkToSP = x.bNeedToTalkToSP;
                    x.custbOfflineMeet = x.bOfflineMeet;
                    return x;
                });

                console.log("SPM LISt==", tempSPMerviceList)

                var masterAllServiceRequests = [...tempLPMServiceList, ...tempSPMerviceList];
                let sortedServiceRequestsDesc = masterAllServiceRequests.sort((a, b) => {
                    return parseInt(b.nResourceInstanceId) - parseInt(a.nResourceInstanceId);
                })
                setEditingServiceRequestList(sortedServiceRequestsDesc);
            }
            else {
                toast("", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }
        }).catch((error) => {
            setIsLoading(false);
            if (error.response.data.detail) {
                toast(String(error.response.data.detail), {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }
            else if (error.response.data.message) {
                toast(String(error.response.data.message), {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }
            else {
                toast("Internal server error", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }

        });
    }

    const onFilterSearchClick = () => {
        // if(confirmationChecked){
        //     getFilterDataExternalService(tableInstance, true)
        // } else {
        getExternalPartnerServices(tableInstance, true)
        // }   
    }

    const getFilterDataExternalService = (instance, flag = false) => {
        if (!instance) return;
        if (!tableInstance) setTableInstance(instance);
        const { page } = instance.state ?? { page: 0 };
        let icurrentPage = page;
        if (!flag && isNaN(icurrentPage)) return;
        const pageSize = selectedPageSizeOption.value;

        if (flag || isNaN(icurrentPage)) {
            icurrentPage = 0;
        }

        if (icurrentPage != currentPage) {
            setExpandedChange({});
        }

        let filterParameters = {
            page_no: icurrentPage + 1,
            page_size: pageSize
            //...sortParams,
        };

        if (selectedOppType) {
            filterParameters.service_codes = [selectedOppType.value]
        }

        if (selectedOppTitle) {
            filterParameters.ResourceName = selectedOppTitle.value
        }

        if (confirmationChecked) {
            filterParameters.bConfirmation_tag = confirmationChecked
        }

        setIsLoading(true);
        const { tempServices } = api.getExternalPartnerFilterConfirmationTag(filterParameters).then(({ data }) => {
            setIsLoading(false);
            if (data) {
                setcurrentPage(icurrentPage);
                setPages(data.total_pages);
                setPageSize(pageSize);
                setDisplayRecordCount({ ...displayRecordCount, count: data?.total_count })
                setUnReadFeedbackCount(data.unread_feedbacks);
                setFollowUpCount(data.todays_follow_up_count || 0);
                setAllFollowUpCount(data.all_follow_up_count || 0)
                let tempLPMServiceList = data.ServiceRequests.map((x) => {
                    x.custrefSRState = x.refSRState;
                    x.custsSRCancellationReason = x.sSRCancellationReason;
                    x.custssSRCancellationReasonOtherDescription = x.sSRCancellationReasonOtherDescription;
                    x.custsNotesHH = null;
                    x.custdtFollowupOn = null;
                    x.custsFollowupNotes = null;
                    x.serviceFrom = "LPM";
                    x.custOtherServiceInfo = x.sOtherServicesInfo;
                    x.custfGovtCharges = x.ext_sp_charges ? (x.ext_sp_charges.fGovtCharges) : (null);
                    x.custfAffiliateFees = x.ext_sp_charges ? (x.ext_sp_charges.fAffiliateFees) : (null);
                    x.custfProfessionalCharges = x.ext_sp_charges ? (x.ext_sp_charges.fProfessionalCharges) : (null);
                    x.custfTotalCharges = x.ext_sp_charges ? (x.ext_sp_charges.fTotalCharges) : (null);
                    x.custChargesid = x.ext_sp_charges ? (x.ext_sp_charges.id) : (null);
                    x.custsCallStatus = x.sCallStatus;
                    x.custsUpdateNoteForAllServicesInPackage = false;
                    x.custbNeedToTalkToSP = x.bNeedToTalkToSP;
                    x.custbOfflineMeet = x.bOfflineMeet;
                    return x;
                });

                let tempSPMerviceList = data.Services.map((x) => {
                    x.custrefSRState = x.refCurrentState.sServiceState;
                    x.custsSRCancellationReason = x.sServiceCancellationReason;
                    x.custssSRCancellationReasonOtherDescription = x.sServiceCancellationReasonOtherDescription;
                    x.custsNotesHH = null;
                    x.custdtFollowupOn = null;
                    x.custsFollowupNotes = null;
                    x.serviceFrom = "SPM";
                    x.OtherServiceInfo = null;
                    x.custOtherServiceInfo = x.sOtherServicesInfo;
                    x.custfGovtCharges = x.ext_sp_charges ? (x.ext_sp_charges.fGovtCharges) : (null);
                    x.custfAffiliateFees = x.ext_sp_charges ? (x.ext_sp_charges.fAffiliateFees) : (null);
                    x.custfProfessionalCharges = x.ext_sp_charges ? (x.ext_sp_charges.fProfessionalCharges) : (null);
                    x.custfTotalCharges = x.ext_sp_charges ? (x.ext_sp_charges.fTotalCharges) : (null);
                    x.custChargesid = x.ext_sp_charges ? (x.ext_sp_charges.id) : (null);
                    x.custsCallStatus = x.sCallStatus;
                    x.custsUpdateNoteForAllServicesInPackage = false;
                    x.custbNeedToTalkToSP = x.bNeedToTalkToSP;
                    x.custbOfflineMeet = x.bOfflineMeet;
                    return x;
                });

                console.log("SPM LISt==", tempSPMerviceList)

                var masterAllServiceRequests = [...tempLPMServiceList, ...tempSPMerviceList];
                let sortedServiceRequestsDesc = masterAllServiceRequests.sort((a, b) => {
                    return parseInt(b.nResourceInstanceId) - parseInt(a.nResourceInstanceId);
                })
                setEditingServiceRequestList(sortedServiceRequestsDesc);
            }
            else {
                toast("", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }
        }).catch((error) => {
            setIsLoading(false);
            if (error.response.data.detail) {
                toast(String(error.response.data.detail), {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }
            else if (error.response.data.message) {
                toast(String(error.response.data.message), {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }
            else {
                toast("Internal server error", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }

        });
    }

    const processFilters = (filter) => {
        let filterNames = ""
        if (filter.length > 1) {
            filterNames = filter.map(city => city.value).join(", ");
        } else if (filter.length === 1) {
            filterNames = filter[0].value;
        }

        return filterNames
    }


    const getExternalPartnerServices = (instance, flag = false) => {
        if (!instance) return;
        if (!tableInstance) setTableInstance(instance);
        if (history.location.pathname.includes("/home/spled-service-requests")) {
            if (!selectedExternalServicePartner) return;
        }

        const { page } = instance.state ?? { page: 0 };
        let icurrentPage = page;
        if (!flag && isNaN(icurrentPage)) return;
        //const pageSize = instance.state.pageSize;
        //setExpandedChange({});
        const pageSize = selectedPageSizeOption.value;

        if (flag || isNaN(icurrentPage)) {
            icurrentPage = 0;
        }

        if (icurrentPage != currentPage) {
            setExpandedChange({});
        }

        //let sortParams = null;
        //if (instance.state.sorted.length > 0) {
        //const { id, desc } = instance.state.sorted[0];
        //sortParams = { column: id, desc };
        //}

        let serviceRequestListtemp2 = [];
        selectedServiceNameListForFilter.map((e) => {
            if (e.value != "*") {
                serviceRequestListtemp2.push(e.value);
            }
        });
        const serviceRequestList = serviceRequestListtemp2;

        let servicestatusListtemp2 = [];
        selectedServiceStatusListForFilter.map((e) => {
            if (e.value != "*") {
                servicestatusListtemp2.push(e.value);
            }
        });
        const serviceStatusList = servicestatusListtemp2;

        let serviceStatusFilter = [];
        serviceStatusList.map((e) => {
            if (e === "Willing to Pay") {
                serviceStatusFilter.push("Ready For Progression:Partner");
                serviceStatusFilter.push("Partial/ Full Payment Pending");
            }
            else if (e === "Payment Received") {
                serviceStatusFilter.push("Payment Confirmed By Partner");
                serviceStatusFilter.push("Ready For Progression:deAsra");
            }
            else {
                serviceStatusFilter.push(e);
            }
        });
        const statusList = serviceStatusFilter;

        let ResourceNamesTemp = []
        selectedOppTitle.map((e) => {
            if (e.value != "*") {
                ResourceNamesTemp.push(e.value)
            }
        })

        let filterParameters = {
            page_no: icurrentPage + 1,
            page_size: pageSize
            //...sortParams,
        };

        //let filterParameters = {};
        if (serviceRequestList.length) {
            filterParameters.service_codes = serviceRequestList;
        }
        if (statusList.length) {
            filterParameters.statusList = statusList;
        }

        if (selectedRequestedaCallBackOption && selectedRequestedaCallBackOption.value == 'yes') {
            filterParameters.bRequestedCallBack = true;
        }
        else if (selectedRequestedaCallBackOption && selectedRequestedaCallBackOption.value == 'no') {
            filterParameters.bRequestedCallBack = false;
        }

        if (selectedCallStatusOptionForFilter && selectedCallStatusOptionForFilter.value != 'all') {
            filterParameters.sCallStatus = selectedCallStatusOptionForFilter.value;
        }


        if (selectedofflinemeetoptionsForFilter && selectedofflinemeetoptionsForFilter.value != 'all') {
            filterParameters.bOfflineMeet = selectedofflinemeetoptionsForFilter.value;
        }

        if(selectedOppType){
            filterParameters.service_codes = [selectedOppType.value]
        }

        if (selectedOppTitle) {
            filterParameters.ResourceName = ResourceNamesTemp
        }

        // if(selectedOppTitle.length > 0){
        //     filterParameters.ResourceName = processFilters(selectedOppTitle)
        // }

        if (confirmationChecked) {
            filterParameters.bConfirmation_tag = confirmationChecked
        }

        if (selectedBusinessSector.length > 0) {
            filterParameters.sBusinessSector = processFilters(selectedBusinessSector)
        }

        if (selectedBusinessCity.length > 0) {
            filterParameters.sBusinessCity = processFilters(selectedBusinessCity)
        }

        if (selectedJpmcEligible) {
            filterParameters.JPMC_eligible = selectedJpmcEligible.value
        }
        if (selectedNoShow) {
            filterParameters.bNoShow = selectedNoShow.value
        }
        // if(selectedofflinemeetoptionsForFilter&&selectedofflinemeetoptionsForFilter.value=='Opted')
        // {
        //     filterParameters.bOfflineMeet=true;
        // }
        // else if(selectedofflinemeetoptionsForFilter&&selectedofflinemeetoptionsForFilter.value=='Not Opted')
        // {
        //     filterParameters.bOfflineMeet=false;
        // }







        if (selectedNeedToTalkToSPOption && selectedNeedToTalkToSPOption.value == 'yes') {
            filterParameters.bNeedToTalkToSP = true;
        }
        else if (selectedNeedToTalkToSPOption && selectedNeedToTalkToSPOption.value == 'no') {
            filterParameters.bNeedToTalkToSP = false;
        }


        // if(selectedofflinemeetoptions&&selectedofflinemeetoptions.value=='Opted')
        // {
        //     filterParameters.bOfflineMeet=true;
        // }
        // else if(selectedofflinemeetoptions&&selectedofflinemeetoptions.value=='Not Opted')
        // {
        //     filterParameters.bOfflineMeet=false;
        // }


        if (selectedRequestedByOption && selectedRequestedByOption.value == 'ehh') {
            filterParameters.req_by = 'ehh';
        }
        else if (selectedRequestedByOption && selectedRequestedByOption.value == 'user') {
            filterParameters.req_by = 'user';
        }

        if (searchTerm) {
            filterParameters.search_value = searchTerm;
        }

        if (fromDate) {
            filterParameters.fromDate = fromDate;
        }

        if (toDate) {
            filterParameters.toDate = adjustedToDate(toDate);;
        }

        if (history.location.pathname.includes("/home/spled-service-requests") && selectedExternalServicePartner) {
            filterParameters.email = selectedExternalServicePartner.value;
        }

        if (selectedPackageNameListForFilter) {
            filterParameters.nPackageCatalogueId = selectedPackageNameListForFilter.value;
        }

        if (requestWithinTAT) {
            if (requestWithinTAT === "yes") {
                filterParameters.within_tat = "True";
            }
            else {
                filterParameters.within_tat = "False";
            }
        }

        setIsLoading(true);
        const { tempServices } = api.getExternalPartnerServices(filterParameters).then(({ data }) => {
            setIsLoading(false);
            if (data) {
                setcurrentPage(icurrentPage);
                setPages(data.total_pages);
                setPageSize(pageSize);
                setDisplayRecordCount({...displayRecordCount, count: data?.total_count})
                setUnReadFeedbackCount(data.unread_feedbacks);
                setFollowUpCount(data.todays_follow_up_count || 0);
                setAllFollowUpCount(data.all_follow_up_count || 0)
                let tempLPMServiceList = data.ServiceRequests.map((x) => {
                    x.custrefSRState = x.refSRState;
                    x.custsSRCancellationReason = x.sSRCancellationReason;
                    x.custssSRCancellationReasonOtherDescription = x.sSRCancellationReasonOtherDescription;
                    x.custsNotesHH = null;
                    x.custdtFollowupOn = null;
                    x.custsFollowupNotes = null;
                    x.serviceFrom = "LPM";
                    x.custOtherServiceInfo = x.sOtherServicesInfo;
                    x.custfGovtCharges = x.ext_sp_charges ? (x.ext_sp_charges.fGovtCharges) : (null);
                    x.custfAffiliateFees = x.ext_sp_charges ? (x.ext_sp_charges.fAffiliateFees) : (null);
                    x.custfProfessionalCharges = x.ext_sp_charges ? (x.ext_sp_charges.fProfessionalCharges) : (null);
                    x.custfTotalCharges = x.ext_sp_charges ? (x.ext_sp_charges.fTotalCharges) : (null);
                    x.custChargesid = x.ext_sp_charges ? (x.ext_sp_charges.id) : (null);
                    x.custsCallStatus = x.sCallStatus;
                    x.custsUpdateNoteForAllServicesInPackage = false;
                    x.custbNeedToTalkToSP = x.bNeedToTalkToSP;
                    x.custbOfflineMeet = x.bOfflineMeet;
                    return x;
                });

                let tempSPMerviceList = data.Services.map((x) => {
                    x.custrefSRState = x.refCurrentState.sServiceState;
                    x.custsSRCancellationReason = x.sServiceCancellationReason;
                    x.custssSRCancellationReasonOtherDescription = x.sServiceCancellationReasonOtherDescription;
                    x.custsNotesHH = null;
                    x.custdtFollowupOn = null;
                    x.custsFollowupNotes = null;
                    x.serviceFrom = "SPM";
                    x.OtherServiceInfo = null;
                    x.custOtherServiceInfo = x.sOtherServicesInfo;
                    x.custfGovtCharges = x.ext_sp_charges ? (x.ext_sp_charges.fGovtCharges) : (null);
                    x.custfAffiliateFees = x.ext_sp_charges ? (x.ext_sp_charges.fAffiliateFees) : (null);
                    x.custfProfessionalCharges = x.ext_sp_charges ? (x.ext_sp_charges.fProfessionalCharges) : (null);
                    x.custfTotalCharges = x.ext_sp_charges ? (x.ext_sp_charges.fTotalCharges) : (null);
                    x.custChargesid = x.ext_sp_charges ? (x.ext_sp_charges.id) : (null);
                    x.custsCallStatus = x.sCallStatus;
                    x.custsUpdateNoteForAllServicesInPackage = false;
                    x.custbNeedToTalkToSP = x.bNeedToTalkToSP;
                    x.custbOfflineMeet = x.bOfflineMeet;
                    return x;
                });

                console.log("SPM LISt==",tempSPMerviceList)

                var masterAllServiceRequests = [...tempLPMServiceList, ...tempSPMerviceList];
                let sortedServiceRequestsDesc = masterAllServiceRequests.sort((a, b) => {
                    return parseInt(b.nResourceInstanceId) - parseInt(a.nResourceInstanceId);
                })
                setEditingServiceRequestList(sortedServiceRequestsDesc);
            }
            else {
                toast("", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }
        }).catch((error) => {
            setIsLoading(false);
            if (error.response.data.detail) {
                toast(String(error.response.data.detail), {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }
            else if (error.response.data.message) {
                toast(String(error.response.data.message), {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }
            else {
                toast("Internal server error", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }

        });
    }
    
    const onServiceRequestsStateChange = (option, service) => {
        /*let tempMappedServices = editingServiceRequestList.map((x) => {
            if (x.nResourceInstanceId == service.nResourceInstanceId) 
            {
                x.refSRState= option.value;
            }
            return x;
        });
        setEditingServiceRequestList(tempMappedServices);*/

        const updated = {
            ...selectedServiceForEdit,
            custrefSRState: option.value,
            custsSRCancellationReason: null,
            custssSRCancellationReasonOtherDescription: null
        };
        setSelectedServiceForEdit(updated);
    };

    const onustomerNeedAnyOtherServiceOptionChange = (option, service) => {
        if (option) {
            const updated = {
                ...selectedServiceForEdit,
                custOtherServiceInfo: option.value,
            };
            setSelectedServiceForEdit(updated);
        }
        else {
            const updated = {
                ...selectedServiceForEdit,
                custOtherServiceInfo: null
            };
            setSelectedServiceForEdit(updated);
        }
    };

    const onCallStatusOptionChange = (option, service) => {
        if (option) {
            const updated = {
                ...selectedServiceForEdit,
                custsCallStatus: option.value,
            };
            setSelectedServiceForEdit(updated);
        }
        else {
            const updated = {
                ...selectedServiceForEdit,
                custsCallStatus: null
            };
            setSelectedServiceForEdit(updated);
        }
    };

    const onNeedToTalkToSPOptionChange = (option, service) => {
        if (option) {
            const updated = {
                ...selectedServiceForEdit,
                custbNeedToTalkToSP: option.value,
            };
            setSelectedServiceForEdit(updated);
        }
        else {
            const updated = {
                ...selectedServiceForEdit,
                custbNeedToTalkToSP: null
            };
            setSelectedServiceForEdit(updated);
        }
    };

    const onCancellationReasonChange = (option, service) => {
        /*let tempMappedServices = editingServiceRequestList.map((x) => {
            if (x.nResourceInstanceId == service.nResourceInstanceId) 
            {
                if(option)
                {
                    x.sSRCancellationReason= option.value;
                }
                else{
                    x.sSRCancellationReason=null;
                }
                
            }
            return x;
        });
        setEditingServiceRequestList(tempMappedServices);*/

        if (option) {
            const updated = {
                ...selectedServiceForEdit,
                custsSRCancellationReason: option.value
            };
            setSelectedServiceForEdit(updated);
        }
        else {
            const updated = {
                ...selectedServiceForEdit,
                custsSRCancellationReason: null
            };
            setSelectedServiceForEdit(updated);
        }
    };

    const onRowDoubleClick = async (e, service) => {

        if (selectedServiceForEdit) {
            const found = find(editingServiceRequestList, {
                nResourceInstanceId: selectedServiceForEdit.nResourceInstanceId,
            });
            const statusLogs = await api.getStateAuditLogSPM(service?.nResourceInstanceId);
            if (found && selectedServiceForEdit != found) {
                createStateDropdownForSelectedService(service, statusLogs);
                setSelectedServiceForEdit(service);
                //setSelectedSecondServiceForEdit(service);
                //setShowConfirmationModal(true);
            }
            else {
                createStateDropdownForSelectedService(service, statusLogs);
                setSelectedServiceForEdit(service);
                setSelectedSecondServiceForEdit();
            }
        }
        else {
            console.log('selectedServiceForEdit?.nResourceInstanceId2',service?.nResourceInstanceId)
            const statusLogs = await api.getStateAuditLogSPM(service?.nResourceInstanceId);
            createStateDropdownForSelectedService(service, statusLogs);
            setSelectedServiceForEdit(service);
            setSelectedSecondServiceForEdit();
        }



    };

    const onSelectSecondService = async() => {
        console.log('selectedSecondServiceForEdit?.nResourceInstanceId3',selectedSecondServiceForEdit?.nResourceInstanceId)
        const statusLogs = await api.getStateAuditLogSPM(selectedSecondServiceForEdit.nResourceInstanceId);
        setShowConfirmationModal(false);
        
        createStateDropdownForSelectedService(selectedSecondServiceForEdit, statusLogs);
        setSelectedServiceForEdit(selectedSecondServiceForEdit);
        setSelectedSecondServiceForEdit();
    };

    // const createStateDropdownForSelectedService = (service) => {
    //     console.log("Service==", service)
    //     let tempStatusArray = [];
    //     tempStatusArray.push({ value: "Requested", label: "Requested", isDisabled: true });
    //     tempStatusArray.push({ value: "Eligible", label: "Eligible", isDisabled: true });
    //     if (service.sPaymentReceiver == "Partner") {
    //         tempStatusArray.push({ value: "Quotation Sent", label: "Quotation Sent", isDisabled: true });
    //         if (service.custrefSRState == "Ready For Progression") {
    //             tempStatusArray.push({ value: "Ready For Progression", label: "Willing to Pay", isDisabled: true });

    //         }
    //         else {
    //             if (service.nPackageInstanceId) {
    //                 if (service.custrefSRState == "Partial/ Full Payment Pending") {
    //                     tempStatusArray.push({ value: "Partial/ Full Payment Pending", label: "Willing to Pay", isDisabled: true });

    //                 }
    //                 else {
    //                     tempStatusArray.push({ value: "Prepared", label: "Willing to Pay", isDisabled: true });
    //                 }
    //             }
    //             else {
    //                 tempStatusArray.push({ value: "Prepared", label: "Willing to Pay", isDisabled: true });
    //             }
    //         }
    //         tempStatusArray.push({ value: "Awaiting for information/Documents", label: "Awaiting for information/Documents", isDisabled: true });
    //         tempStatusArray.push({ value: "Payment Confirmed By Partner", label: "Payment Received", isDisabled: true });
    //     }

    //     if (service.sPaymentReceiver == "deAsra") {
    //         if (service.custrefSRState == "Partial/ Full Payment Pending") {
    //             tempStatusArray.push({ value: "Partial/ Full Payment Pending", label: "Willing to Pay", isDisabled: true });
    //         }
    //         else {
    //             tempStatusArray.push({ value: "Prepared", label: "Willing to Pay", isDisabled: true });
    //         }

    //         if (service.custrefSRState == "Ready For Progression") {
    //             tempStatusArray.push({ value: "Ready For Progression", label: "Payment Received", isDisabled: true });
    //             tempStatusArray.push({ value: "Awaiting for information/Documents", label: "Awaiting for information/Documents", isDisabled: true });
    //         }
    //         else {
    //             tempStatusArray.push({ value: "Payment Received", label: "Payment Received", isDisabled: true });
    //             tempStatusArray.push({ value: "Awaiting for information/Documents", label: "Awaiting for information/Documents", isDisabled: true });
    //         }
    //     }

    //     tempStatusArray.push({ value: "Service Delivery Started", label: "Service Delivery Started", isDisabled: true });
    //     tempStatusArray.push({ value: "Service deliverables ready", label: "Service deliverables ready", isDisabled: true });


    //     if(!service.nPackageInstanceId){
    //         if (service.sPaymentMode == "2_Step_Payment") {
    //             tempStatusArray.push({ value: "Full Payment Requested", label: "Full Payment Requested", isDisabled: true });
    //             tempStatusArray.push({ value: "Full Payment Received", label: "Full Payment Received", isDisabled: true });
    //         }
    //     }


    //     tempStatusArray.push({ value: "Delivered", label: "Delivered", isDisabled: true });
    //     tempStatusArray.push({ value: "Cancelled", label: "Cancelled" });
    //     tempStatusArray.push({ value: "Refunded", label: "Refunded" });

    //     if (service.custrefSRState !== "Cancelled") {
    //         for (let i = 0; i < tempStatusArray.length; i++) {
    //             if (service.sPaymentReceiver == "deAsra") {
    //                 if (service.sPaymentMode == "No_Payment") {
    //                     if (i <= 2) {
    //                         tempStatusArray[i].isDisabled = false;
    //                         if (service.custrefSRState == 'Ready For Progression') {
    //                             if(service.sServiceCode == 'DEPRELISTING') {
    //                                 console.log("1st")
    //                                 tempStatusArray[i + 1].isDisabled = true;
    //                                 tempStatusArray[i + 2].isDisabled = true;
    //                                 tempStatusArray[i + 3].isDisabled = true;
    //                                 tempStatusArray[i + 4].isDisabled = true;
    //                                 tempStatusArray[i + 5].isDisabled = false;
    //                             }else {
    //                                 console.log("2nd")
    //                                 tempStatusArray[i + 1].isDisabled = false;
    //                             }


    //                         }
    //                     }
    //                     else {
    //                         if (service.custrefSRState == tempStatusArray[i].value) {
    //                             tempStatusArray[i].isDisabled = false;
    //                             tempStatusArray[i + 1].isDisabled = false;
    //                             break;
    //                         }
    //                     }
    //                 }
    //                 else {
    //                     if (i <= 3) {
    //                         tempStatusArray[i].isDisabled = false;
    //                         if (service.custrefSRState == 'Ready For Progression') {
    //                             if(service.sServiceCode == 'DEPRELISTING') {
    //                                 console.log("3st")
    //                                 // tempStatusArray[i + 1].isDisabled = true;
    //                                 // tempStatusArray[i + 2].isDisabled = true;
    //                                 tempStatusArray[i + 3].isDisabled = true;
    //                                 tempStatusArray[i + 4].isDisabled = true;
    //                                 tempStatusArray[i + 5].isDisabled = false;
    //                             }else {
    //                                 console.log("4nd")
    //                                 tempStatusArray[i + 1].isDisabled = false;
    //                             }
    //                         }
    //                     }
    //                     else {
    //                         if (service.custrefSRState == tempStatusArray[i].value) {
    //                             tempStatusArray[i].isDisabled = false;
    //                             tempStatusArray[i + 1].isDisabled = false;
    //                             break;
    //                         }
    //                     }
    //                 }

    //             }
    //             else if (service.sPaymentReceiver == "Partner") {
    //                 if (i <= 3) {
    //                     tempStatusArray[i].isDisabled = false;
    //                     if (service.custrefSRState == 'Ready For Progression') {
    //                         tempStatusArray[i + 1].isDisabled = false;
    //                     }
    //                 }
    //                 else {

    //                     if (service.custrefSRState == tempStatusArray[i].value) {
    //                         tempStatusArray[i].isDisabled = false;
    //                         tempStatusArray[i + 1].isDisabled = false;
    //                         break;
    //                     }
    //                 }
    //             }
    //             else {
    //                 if (service.custrefSRState == tempStatusArray[i].value) {
    //                     tempStatusArray[i].isDisabled = false;
    //                     tempStatusArray[i + 1].isDisabled = false;

    //                     /*if(service.sPaymentReceiver=="deAsra")
    //                     {
    //                         if(service.custrefSRState=="Partial/ Full Payment Pending")
    //                         {
    //                             tempStatusArray[i+1].isDisabled=true;
    //                         }
    //                         else
    //                         {
    //                             tempStatusArray[i+1].isDisabled=false;
    //                         }
    //                     }
    //                     else
    //                     {
    //                         tempStatusArray[i+1].isDisabled=false;
    //                     } */
    //                     break;
    //                 }
    //             }

    //         }

    //         for (let i = 0; i < tempStatusArray.length; i++) {
    //             if (service.custrefSRState == tempStatusArray[i].value) {
    //                 break;
    //             }
    //             else {
    //                 tempStatusArray[i].isDisabled = true;
    //             }
    //         }

    //         if (service.nPackageInstanceId) {
    //             if (service.sPaymentReceiver == "Partner") {
    //                 /*if(service.sPaymentMode=="2_Step_Payment")
    //                 {
    //                     if(service.custrefSRState=="Ready For Progression")
    //                     {
    //                         tempStatusArray[3].isDisabled=false;
    //                         tempStatusArray[4].isDisabled=true;
    //                         tempStatusArray[5].isDisabled=false;
    //                     }
    //                     else if(service.custrefSRState=="Service Delivery Start")
    //                     {
    //                         tempStatusArray[6].isDisabled=false;
    //                         tempStatusArray[7].isDisabled=true;
    //                         tempStatusArray[8].isDisabled=true;
    //                         tempStatusArray[9].isDisabled=true;
    //                         tempStatusArray[10].isDisabled=false;
    //                     }
    //                 }
    //                 else
    //                 {
    //                     if(service.custrefSRState=="Ready For Progression")
    //                     {
    //                         tempStatusArray[3].isDisabled=false;
    //                         tempStatusArray[4].isDisabled=true;
    //                         tempStatusArray[5].isDisabled=false;
    //                     }
    //                 }*/

    //                 // if(service.custrefSRState=="Partial/ Full Payment Pending")
    //                 // {
    //                 //     tempStatusArray[4].isDisabled=false;
    //                 // }

    //                 if (service.sPaymentMode == "2_Step_Payment") {
    //                     if (service.custrefSRState == "Service Delivery Started") {
    //                         tempStatusArray[6].isDisabled = false;
    //                         tempStatusArray[7].isDisabled = true;
    //                         tempStatusArray[8].isDisabled = true;
    //                         tempStatusArray[9].isDisabled = true;
    //                         tempStatusArray[10].isDisabled = false;
    //                     }
    //                 }
    //             }

    //             if (service.sPaymentReceiver == "deAsra") {
    //                 if (service.sPaymentMode == "2_Step_Payment") {
    //                     if (service.custrefSRState == "Service Delivery Started") {
    //                         tempStatusArray[5].isDisabled = false;
    //                         tempStatusArray[6].isDisabled = false;
    //                         tempStatusArray[7].isDisabled = true;
    //                         tempStatusArray[8].isDisabled = true;
    //                         tempStatusArray[9].isDisabled = false;
    //                     }
    //                 }
    //             }
    //         }

    //         if (service.bCouponApplied && (service.fAmountSecond <= service.fDiscountAmount)) {
    //             if (service.sPaymentMode == "2_Step_Payment") {
    //                 if (service.custrefSRState == "Service Delivery Started") {
    //                     tempStatusArray[6].isDisabled = false;
    //                     tempStatusArray[7].isDisabled = true;
    //                     tempStatusArray[8].isDisabled = true;
    //                     tempStatusArray[9].isDisabled = true;
    //                     tempStatusArray[10].isDisabled = false;
    //                 }
    //             }

    //             if (service.sPaymentReceiver == "deAsra") {
    //                 if (service.sPaymentMode == "2_Step_Payment") {
    //                     if (service.custrefSRState == "Service Delivery Started") {
    //                         tempStatusArray[5].isDisabled = false;
    //                         tempStatusArray[6].isDisabled = true;
    //                         tempStatusArray[7].isDisabled = true;
    //                         tempStatusArray[8].isDisabled = true;
    //                         tempStatusArray[9].isDisabled = false;
    //                     }
    //                     // if (service.custrefSRState == "Service deliverables ready") {
    //                     //     tempStatusArray[6].isDisabled = false;
    //                     //     tempStatusArray[7].isDisabled = false;
    //                     //     tempStatusArray[8].isDisabled = false;
    //                     //     tempStatusArray[9].isDisabled = false;
    //                     // }
    //                 }
    //             }
    //         }

    //         //Jump status logic
    //         for (let i = 0; i < tempStatusArray.length; i++) {
    //             if (service.sPaymentReceiver == "Partner") {
    //                 // if(tempStatusArray[i].value=="Payment Confirmed By Partner"&&service.custrefSRState=="Payment Confirmed By Partner")
    //                 // {
    //                 //     tempStatusArray[i+2].isDisabled=false;
    //                 //     tempStatusArray[5].isDisabled=true
    //                 // }
    //                 if (tempStatusArray[i].value == "Ready For Progression" && service.custrefSRState == "Ready For Progression") {
    //                     tempStatusArray[i].isDisabled = false;
    //                     tempStatusArray[i + 1].isDisabled = false;
    //                     // tempStatusArray[4].isDisabled=true
    //                 }
    //                 else if (tempStatusArray[i].value == "Awaiting for information/Documents" && service.custrefSRState == "Awaiting for information/Documents") {
    //                     tempStatusArray[i].isDisabled = false;
    //                     tempStatusArray[i + 1].isDisabled = false;
    //                 } else if (tempStatusArray[i].value == "Payment Confirmed By Partner" && service.custrefSRState == "Payment Confirmed By Partner") {
    //                     tempStatusArray[i].isDisabled = false;
    //                     tempStatusArray[i + 1].isDisabled = false;
    //                 }
    //             }
    //             else {
    //                 if (tempStatusArray[i].value == "Ready For Progression" && service.custrefSRState == "Ready For Progression") {
    //                     if(service.sServiceCode == 'DEPRELISTING') {
    //                         console.log("INNN")
    //                         tempStatusArray[i + 1].isDisabled = true;
    //                     } else{
    //                         tempStatusArray[i + 1].isDisabled = false;
    //                     }

    //                 } else if (tempStatusArray[i].value == "Service deliverables ready" && service.custrefSRState == "Service deliverables ready") {
    //                     tempStatusArray[i + 1].isDisabled = false;
    //                 } else if (tempStatusArray[i].value == "Full Payment Requested" && service.custrefSRState == "Full Payment Requested") {
    //                     tempStatusArray[i + 1].isDisabled = false;

    //                 }
    //             }
    //         }
    //     }
    //     setMasterServiceRequestStates(tempStatusArray);
    //     console.log("Master", masterServiceRequestStates)
    // };

    const createStateDropdownForSelectedService = (service, statusLogs) => {
        console.log("Service==", service)
        let normalizedState =
    service.custrefSRState === "Info & Docs Received"
      ? "Awaiting for information/Documents"
      : service.custrefSRState;
        let tempStatusArray = [];
        tempStatusArray.push({ value: "Requested", label: "Requested", isDisabled: true });
        tempStatusArray.push({ value: "Eligible", label: "Eligible", isDisabled: true });
        const isSudhirGijare =
            service?.refExternalServicePartner === "Mr. Sudhir Gijare" ||
            service?.ext_sp_org === "Mr. Sudhir Gijare";

        const isLongTermPackage = service?.sPackageOfferTitle === "Long Term Engagement Package" || service?.sPackageOfferTitle === "Long Term Engagement Package1";
        if (service.sPaymentReceiver == "Partner") {
            if (service.sPackageOfferPaymentType && service.sPackageOfferPaymentType === "Paid") {
                if(service?.nPackageInstanceId !== null && !isLongTermPackage || (isLongTermPackage && isSudhirGijare)){
                if (normalizedState == "Partial/ Full Payment Pending") {
                    tempStatusArray.push({ value: "Partial/ Full Payment Pending", label: "Willing to Pay", isDisabled: true });
                }
                else {
                    tempStatusArray.push({ value: "Prepared", label: "Willing to Pay", isDisabled: true });
                }
                }

                if (normalizedState == "Ready For Progression") {
                    tempStatusArray.push({ value: "Ready For Progression", label: "Payment Received", isDisabled: true });
                    tempStatusArray.push({ value: "Awaiting for information/Documents", label: "Awaiting for information/Documents", isDisabled: true });
                }
                else {
                    tempStatusArray.push({ value: "Payment Received", label: "Payment Received", isDisabled: true });
                    tempStatusArray.push({ value: "Awaiting for information/Documents", label: "Awaiting for information/Documents", isDisabled: true });
                }

            } else {
                if (normalizedState == "Prepared" && service?.refExternalServicePartner !== "Mr. Sudhir Gijare") {
                    // if(service.sPaymentReceiver === "Partner" && (service?.refExternalServicePartner === "Prakash Agashe" || service?.ext_sp_org === "Mr. Sudhir Gijare")) {
                    if(service?.nPackageInstanceId !== null && !isLongTermPackage || (isLongTermPackage && isSudhirGijare)){
                    tempStatusArray.push({ value: "Prepared", label: "Willing to Pay", isDisabled: true });

                    }else{
                    tempStatusArray.push({ value: "Prepared", label: "Quotation Sent", isDisabled: true });
                    }
                    tempStatusArray.push({ value: "Payment Received", label: "Payment Received", isDisabled: true });
                }else{
                tempStatusArray.push({ value: "Quotation Sent", label: "Quotation Sent", isDisabled: true });

                }
                if (normalizedState == "Ready For Progression" && normalizedState !== "Prepared") {
                    // tempStatusArray.push({ value: "Ready For Progression", label: "Willing to Pay", isDisabled: true });
                    tempStatusArray.push({ value: "Ready For Progression", label: "Payment Received", isDisabled: true });

                }
                else {
                    if (service.nPackageInstanceId) {
                        // if (normalizedState == "Partial/ Full Payment Pending") {
                        //     tempStatusArray.push({ value: "Partial/ Full Payment Pending", label: "Willing to Pay", isDisabled: true });

                        // }
                        // else {
                        //     tempStatusArray.push({ value: "Prepared", label: "Willing to Pay", isDisabled: true });
                        // }
                    }
                    else {
                        // tempStatusArray.push({ value: "Prepared", label: "Payment Received", isDisabled: true });
                        if(service.sPaymentReceiver === "Partner" && (service?.refExternalServicePartner === "Mr. Sudhir Gijare" || service?.ext_sp_org === "Mr. Sudhir Gijare")) {
                        tempStatusArray.push({ value: "Prepared", label: "Willing to Pay", isDisabled: true });
                        }
                        if (service.sPaymentReceiver === "Partner" && service.sPaymentMode !== "SP_paid_service") {
                            tempStatusArray.push({ value: "Payment Received", label: "Payment Received", isDisabled: true });
                        }
                    }
                }
                tempStatusArray.push({ value: "Awaiting for information/Documents", label: "Awaiting for information/Documents", isDisabled: true });
                if(service.sPaymentReceiver === "Partner" && service.sPaymentMode == "2_Step_Payment" && (service?.refExternalServicePartner?.id  !== 66  || service?.refExternalServicePartner?.sName !== "Mr. Sudhir Gijare")) {
                    tempStatusArray.push({ value: "Payment Confirmed By Partner", label: "Payment Received", isDisabled: true });
                }
            }

        }

        if (service.sPaymentReceiver == "deAsra") {
            if(service.sPackageOfferPaymentType && service.sPackageOfferPaymentType === "Partner Paid"){
                tempStatusArray.push({ value: "Quotation Sent", label: "Quotation Sent", isDisabled: true });
                if (normalizedState == "Ready For Progression") {
                    tempStatusArray.push({ value: "Ready For Progression", label: "Willing to Pay", isDisabled: true });
    
                }
                else {
                    if (service.nPackageInstanceId) {
                        if (normalizedState == "Partial/ Full Payment Pending") {
                            tempStatusArray.push({ value: "Partial/ Full Payment Pending", label: "Willing to Pay", isDisabled: true });
    
                        }
                        else {
                            tempStatusArray.push({ value: "Prepared", label: "Willing to Pay", isDisabled: true });
                        }
                    }
                    else {
                        tempStatusArray.push({ value: "Prepared", label: "Willing to Pay", isDisabled: true });
                    }
                }
                tempStatusArray.push({ value: "Awaiting for information/Documents", label: "Awaiting for information/Documents", isDisabled: true });
                tempStatusArray.push({ value: "Payment Confirmed By Partner", label: "Payment Received", isDisabled: true });
            } else {
                if (normalizedState == "Partial/ Full Payment Pending") {
                    tempStatusArray.push({ value: "Partial/ Full Payment Pending", label: "Willing to Pay", isDisabled: true });
                }
                else {
                    tempStatusArray.push({ value: "Prepared", label: "Willing to Pay", isDisabled: true });
                }
    
                if (normalizedState == "Ready For Progression") {
                    tempStatusArray.push({ value: "Ready For Progression", label: "Payment Received", isDisabled: true });
                    tempStatusArray.push({ value: "Awaiting for information/Documents", label: "Awaiting for information/Documents", isDisabled: true });
                }
                else {
                    tempStatusArray.push({ value: "Payment Received", label: "Payment Received", isDisabled: true });
                    tempStatusArray.push({ value: "Awaiting for information/Documents", label: "Awaiting for information/Documents", isDisabled: true });
                }
            }
            
        }

        tempStatusArray.push({ value: "Service Delivery Started", label: "Service Delivery Started", isDisabled: true });
        tempStatusArray.push({ value: "Service deliverables ready", label: "Service deliverables ready", isDisabled: true });


        if(!service.nPackageInstanceId){
            if (service.sPaymentMode == "2_Step_Payment") {
                if(service.sPaymentReceiver !== "Partner"){
                    tempStatusArray.push({ value: "Full Payment Requested", label: "Full Payment Requested", isDisabled: true });
                    tempStatusArray.push({ value: "Full Payment Received", label: "Full Payment Received", isDisabled: true });
                }else if( service.sPaymentReceiver == "Partner" && (service?.refExternalServicePartner?.id === 66  || service?.refExternalServicePartner?.sName === "Mr. Sudhir Gijare")){
                tempStatusArray.push({ value: "Full Payment Requested", label: "Full Payment Requested", isDisabled: true });
                tempStatusArray.push({ value: "Full Payment Received", label: "Full Payment Received", isDisabled: true });
                }
            }
        }else if(service.nPackageInstanceId){
            if (service.sPaymentMode == "2_Step_Payment") {
                if(service.sPaymentReceiver !== "Partner"){
                    tempStatusArray.push({ value: "Full Payment Requested", label: "Full Payment Requested", isDisabled: true });
                    tempStatusArray.push({ value: "Full Payment Received", label: "Full Payment Received", isDisabled: true });
                }else if( service.sPaymentReceiver == "Partner"){
                tempStatusArray.push({ value: "Full Payment Requested", label: "Full Payment Requested", isDisabled: true });
                tempStatusArray.push({ value: "Full Payment Received", label: "Full Payment Received", isDisabled: true });
                }
            }
        }


        tempStatusArray.push({ value: "Delivered", label: "Delivered", isDisabled: true });
        tempStatusArray.push({ value: "Cancelled", label: "Cancelled" });
        tempStatusArray.push({ value: "Refunded", label: "Refunded" });

        // console.log("Temp Status", tempStatusArray)

        if (normalizedState !== "Cancelled") {
            for (let i = 0; i < tempStatusArray.length; i++) {
                if (service.sPaymentReceiver == "deAsra") {
                    if(service.sPackageOfferPaymentType && service.sPackageOfferPaymentType === "Partner Paid"){
                        if (i <= 3) {
                            tempStatusArray[i].isDisabled = false;
                            if (normalizedState == 'Ready For Progression') {
                                tempStatusArray[i + 1].isDisabled = false;
                            }
                        }
                        else {
    
                            if (normalizedState == tempStatusArray[i].value) {
                                tempStatusArray[i].isDisabled = false;
                                tempStatusArray[i + 1].isDisabled = false;
                                break;
                            }
                        }
                    } else {
                        if (service.sPaymentMode == "No_Payment") {
                            if (i <= 2) {
                                tempStatusArray[i].isDisabled = false;
                                if (normalizedState == 'Ready For Progression') {
                                    if(service.sServiceCode == 'DEPRELISTING') {
                                        console.log("1st")
                                        tempStatusArray[i + 1].isDisabled = true;
                                        tempStatusArray[i + 2].isDisabled = true;
                                        tempStatusArray[i + 3].isDisabled = true;
                                        tempStatusArray[i + 4].isDisabled = true;
                                        tempStatusArray[i + 5].isDisabled = false;
                                    } else {
                                        // console.log("2nd")
                                        tempStatusArray[i + 1].isDisabled = false;
                                    }


                                }
                            }
                            else {
                                if (normalizedState == tempStatusArray[i].value) {
                                    tempStatusArray[i].isDisabled = false;
                                    tempStatusArray[i + 1].isDisabled = false;
                                    break;
                                }
                            }
                        }
                        else {
                            if (i <= 3) {
                                tempStatusArray[i].isDisabled = false;
                                if (normalizedState == 'Ready For Progression') {
                                    if (service.sServiceCode == 'DEPRELISTING') {
                                        // console.log("3st")
                                        // tempStatusArray[i + 1].isDisabled = true;
                                        // tempStatusArray[i + 2].isDisabled = true;
                                        tempStatusArray[i + 3].isDisabled = true;
                                        tempStatusArray[i + 4].isDisabled = true;
                                        tempStatusArray[i + 5].isDisabled = false;
                                    } else {
                                        // console.log("4nd")
                                        tempStatusArray[i + 1].isDisabled = false;
                                    }
                                }
                            }
                            else {
                                if (normalizedState == tempStatusArray[i].value) {
                                    tempStatusArray[i].isDisabled = false;
                                    tempStatusArray[i + 1].isDisabled = false;
                                    break;
                                }
                            }
                        }
                    }


                }
                else if (service.sPaymentReceiver == "Partner") {
                    if (service.sPackageOfferPaymentType && service.sPackageOfferPaymentType === "Paid") {
                        if (service.sPaymentMode == "No_Payment") {
                            if (i <= 2) {
                                tempStatusArray[i].isDisabled = false;
                                if (normalizedState == 'Ready For Progression') {
                                    if (service.sServiceCode == 'DEPRELISTING') {
                                        // console.log("1st")
                                        tempStatusArray[i + 1].isDisabled = true;
                                        tempStatusArray[i + 2].isDisabled = true;
                                        tempStatusArray[i + 3].isDisabled = true;
                                        tempStatusArray[i + 4].isDisabled = true;
                                        tempStatusArray[i + 5].isDisabled = false;
                                    } else {
                                        // console.log("2nd")
                                        tempStatusArray[i + 1].isDisabled = false;
                                    }


                                }
                            }
                            else {
                                if (normalizedState == tempStatusArray[i].value) {
                                    tempStatusArray[i].isDisabled = false;
                                    tempStatusArray[i + 1].isDisabled = false;
                                    break;
                                }
                            }
                        }
                        else {
                            if (i <= 3) {
                                tempStatusArray[i].isDisabled = false;
                                if (normalizedState == 'Ready For Progression') {
                                    if (service.sServiceCode == 'DEPRELISTING') {
                                        console.log("3st")
                                        // tempStatusArray[i + 1].isDisabled = true;
                                        // tempStatusArray[i + 2].isDisabled = true;
                                        tempStatusArray[i + 3].isDisabled = true;
                                        tempStatusArray[i + 4].isDisabled = true;
                                        tempStatusArray[i + 5].isDisabled = false;
                                    } else {
                                        console.log("4nd")
                                        if(service?.nPackageInstanceId !== null && !isLongTermPackage || (isLongTermPackage && isSudhirGijare)){
                                            tempStatusArray[i + 1].isDisabled = false;
                                        }else{
                                            tempStatusArray[i + 2].isDisabled = false;
                                        }
                                    }
                                }
                            }
                            else {
                                        console.log("5th")

                                if (normalizedState == tempStatusArray[i].value) {
                                    tempStatusArray[i].isDisabled = false;
                                    tempStatusArray[i + 1].isDisabled = false;
                                    break;
                                }
                            }
                        }
                    } else {
                        if (i <= 3) {
                                        console.log("6th")
                            if(service?.refExternalServicePartner === "Mr. Sudhir Gijare" || service?.ext_sp_org === "Mr. Sudhir Gijare"){
                                tempStatusArray[i+1].isDisabled = false;

                            }else{
                                tempStatusArray[i].isDisabled = false;
                                
                            }
                            // if (
                            //     service['sPaymentReceiver'] === "Partner" &&
                            //     service['sPaymentMode'] !== "SP_paid_service"
                            // ) {
                            //     tempStatusArray[i + 1].isDisabled = false;
                            // }
                            if (normalizedState == 'Ready For Progression') {
                                tempStatusArray[i + 1].isDisabled = false;
                            }
                        }
                        else {
                                        console.log("7th")


                            if (normalizedState == tempStatusArray[i].value) {
                                tempStatusArray[i].isDisabled = false;
                                tempStatusArray[i + 1].isDisabled = false;
                                break;
                            }
                        }
                    }

                }
                else {
                                        console.log("8th")

                    if (normalizedState == tempStatusArray[i].value) {
                        tempStatusArray[i].isDisabled = false;
                        tempStatusArray[i + 1].isDisabled = false;

                        /*if(service.sPaymentReceiver=="deAsra")
                        {
                            if(normalizedState=="Partial/ Full Payment Pending")
                            {
                                tempStatusArray[i+1].isDisabled=true;
                            }
                            else
                            {
                                tempStatusArray[i+1].isDisabled=false;
                            }
                        }
                        else
                        {
                            tempStatusArray[i+1].isDisabled=false;
                        } */
                        break;
                    }
                }

            }

            for (let i = 0; i < tempStatusArray.length; i++) {
                if (normalizedState == tempStatusArray[i].value) {
                    break;
                }
                else {
                    tempStatusArray[i].isDisabled = true;
                }
            }

            if (service.nPackageInstanceId) {
                if (service.sPaymentReceiver == "Partner") {
                    /*if(service.sPaymentMode=="2_Step_Payment")
                    {
                        if(service.custrefSRState=="Ready For Progression")
                        {
                            tempStatusArray[3].isDisabled=false;
                            tempStatusArray[4].isDisabled=true;
                            tempStatusArray[5].isDisabled=false;
                        }
                        else if(service.custrefSRState=="Service Delivery Start")
                        {
                            tempStatusArray[6].isDisabled=false;
                            tempStatusArray[7].isDisabled=true;
                            tempStatusArray[8].isDisabled=true;
                            tempStatusArray[9].isDisabled=true;
                            tempStatusArray[10].isDisabled=false;
                        }
                    }
                    else
                    {
                        if(service.custrefSRState=="Ready For Progression")
                        {
                            tempStatusArray[3].isDisabled=false;
                            tempStatusArray[4].isDisabled=true;
                            tempStatusArray[5].isDisabled=false;
                        }
                    }*/

                    // if(service.custrefSRState=="Partial/ Full Payment Pending")
                    // {
                    //     tempStatusArray[4].isDisabled=false;
                    // }
                    if(service.sPackageOfferPaymentType && service.sPackageOfferPaymentType === "Paid"){
                        if (service.sPaymentMode == "2_Step_Payment") {
                            if (normalizedState == "Service Delivery Started") {
                                tempStatusArray[5].isDisabled = false;
                                tempStatusArray[6].isDisabled = false;
                                tempStatusArray[7].isDisabled = true;
                                tempStatusArray[8].isDisabled = true;
                                tempStatusArray[9].isDisabled = false;
                            }
                        }
                    } else {
                        if (service.sPaymentMode == "2_Step_Payment") {
                            if (normalizedState == "Service Delivery Started") {
                                tempStatusArray[6].isDisabled = false;
                                tempStatusArray[7].isDisabled = true;
                                tempStatusArray[8].isDisabled = true;
                                tempStatusArray[9].isDisabled = true;
                                tempStatusArray[10].isDisabled = false;
                            }
                        }
                    }

                }

                if (service.sPaymentReceiver == "deAsra") {
                    if (service.sPackageOfferPaymentType && service.sPackageOfferPaymentType === "Partner Paid") {
                        if (service.sPaymentMode == "2_Step_Payment") {
                            if (normalizedState == "Service Delivery Started") {
                                tempStatusArray[6].isDisabled = false;
                                tempStatusArray[7].isDisabled = true;
                                tempStatusArray[8].isDisabled = true;
                                tempStatusArray[9].isDisabled = true;
                                tempStatusArray[10].isDisabled = false;
                            }
                        }
                    } else {
                        if (service.sPaymentMode == "2_Step_Payment") {
                            if (normalizedState == "Service Delivery Started") {
                                tempStatusArray[5].isDisabled = false;
                                tempStatusArray[6].isDisabled = false;
                                tempStatusArray[7].isDisabled = true;
                                tempStatusArray[8].isDisabled = true;
                                tempStatusArray[9].isDisabled = false;
                            }
                        }
                    }

                }
            }

            if (service.bCouponApplied && (service.fAmountSecond <= service.fDiscountAmount)) {
                if (service.sPaymentMode == "2_Step_Payment") {
                    if (normalizedState == "Service Delivery Started") {
                        tempStatusArray[6].isDisabled = false;
                        tempStatusArray[7].isDisabled = true;
                        tempStatusArray[8].isDisabled = true;
                        tempStatusArray[9].isDisabled = true;
                        tempStatusArray[10].isDisabled = false;
                    }
                }

                if (service.sPaymentReceiver == "deAsra") {
                    if (service.sPaymentMode == "2_Step_Payment") {
                        if (normalizedState == "Service Delivery Started") {
                            tempStatusArray[5].isDisabled = false;
                            tempStatusArray[6].isDisabled = true;
                            tempStatusArray[7].isDisabled = true;
                            tempStatusArray[8].isDisabled = true;
                            tempStatusArray[9].isDisabled = false;
                        }
                        // if (service.custrefSRState == "Service deliverables ready") {
                        //     tempStatusArray[6].isDisabled = false;
                        //     tempStatusArray[7].isDisabled = false;
                        //     tempStatusArray[8].isDisabled = false;
                        //     tempStatusArray[9].isDisabled = false;
                        // }
                    }
                }
            }

            //Jump status logic
            for (let i = 0; i < tempStatusArray.length; i++) {
                if (service.sPaymentReceiver == "Partner") {
                    if (service.sPackageOfferPaymentType && service.sPackageOfferPaymentType === "Paid") {
                        if (tempStatusArray[i].value == "Ready For Progression" && normalizedState == "Ready For Progression") {
                            if (service.sServiceCode == 'DEPRELISTING') {
                                console.log("INNN")
                                tempStatusArray[i + 1].isDisabled = true;
                            } else {
                                tempStatusArray[i + 1].isDisabled = false;
                            }

                        } else if (tempStatusArray[i].value == "Service deliverables ready" && normalizedState == "Service deliverables ready") {
                            tempStatusArray[i + 1].isDisabled = false;
                        } else if (tempStatusArray[i].value == "Full Payment Requested" && normalizedState == "Full Payment Requested") {
                            tempStatusArray[i + 1].isDisabled = false;

                        }
                    } else {
                        // if(tempStatusArray[i].value=="Payment Confirmed By Partner"&&service.custrefSRState=="Payment Confirmed By Partner")
                        // {
                        //     tempStatusArray[i+2].isDisabled=false;
                        //     tempStatusArray[5].isDisabled=true
                        // }
                        if (tempStatusArray[i].value == "Ready For Progression" && normalizedState == "Ready For Progression") {
                            tempStatusArray[i].isDisabled = false;
                            tempStatusArray[i + 1].isDisabled = false;
                            // tempStatusArray[4].isDisabled=true
                        }
                        else if (tempStatusArray[i].value == "Awaiting for information/Documents" && normalizedState == "Awaiting for information/Documents") {
                            tempStatusArray[i].isDisabled = false;
                            tempStatusArray[i + 1].isDisabled = false;
                        }
                        else if (tempStatusArray[i].value == "Info & Docs Received" && normalizedState == "Info & Docs Received") {
                            tempStatusArray[i].isDisabled = false;
                            tempStatusArray[i + 1].isDisabled = false;
                        } else if (tempStatusArray[i].value == "Payment Confirmed By Partner" && service.custrefSRState == "Payment Confirmed By Partner") {
                            tempStatusArray[i].isDisabled = false;
                            tempStatusArray[i + 1].isDisabled = false;
                        }
                    }

                }
                else {
                    if (service.sPackageOfferPaymentType && service.sPackageOfferPaymentType === "Partner Paid") {
                        // if(tempStatusArray[i].value=="Payment Confirmed By Partner"&&service.custrefSRState=="Payment Confirmed By Partner")
                        // {
                        //     tempStatusArray[i+2].isDisabled=false;
                        //     tempStatusArray[5].isDisabled=true
                        // }
                        if (tempStatusArray[i].value == "Ready For Progression" && normalizedState == "Ready For Progression") {
                            tempStatusArray[i].isDisabled = false;
                            tempStatusArray[i + 1].isDisabled = false;
                            // tempStatusArray[4].isDisabled=true
                        }
                        else if (tempStatusArray[i].value == "Awaiting for information/Documents" && normalizedState == "Awaiting for information/Documents") {
                            tempStatusArray[i].isDisabled = false;
                            tempStatusArray[i + 1].isDisabled = false;
                        }
                        else if (tempStatusArray[i].value == "Info & Docs Received" && normalizedState == "Info & Docs Received") {
                            tempStatusArray[i].isDisabled = false;
                            tempStatusArray[i + 1].isDisabled = false;
                        } else if (tempStatusArray[i].value == "Payment Confirmed By Partner" && normalizedState == "Payment Confirmed By Partner") {
                            tempStatusArray[i].isDisabled = false;
                            tempStatusArray[i + 1].isDisabled = false;
                        }
                    }
                    else {
                        if (tempStatusArray[i].value == "Ready For Progression" && normalizedState == "Ready For Progression") {
                            if (service.sServiceCode == 'DEPRELISTING') {
                                console.log("INNN")
                                tempStatusArray[i + 1].isDisabled = true;
                            } else {
                                tempStatusArray[i + 1].isDisabled = false;
                            }

                        } else if (tempStatusArray[i].value == "Service deliverables ready" && normalizedState == "Service deliverables ready") {
                            tempStatusArray[i + 1].isDisabled = false;
                        } else if (tempStatusArray[i].value == "Full Payment Requested" && normalizedState == "Full Payment Requested") {
                            tempStatusArray[i + 1].isDisabled = false;

                        }
                        // else if (service.custrefSRState == "Info & Docs Received") {
                        //     tempStatusArray[5].isDisabled = false;

                        // }

                    }

                }
            }
        }
        setMasterServiceRequestStates(tempStatusArray);
        console.log("Master", masterServiceRequestStates)
    };

    const onRowCancelEdit = (e, service) => {
        setSelectedServiceForEdit();
        setSelectedSecondServiceForEdit();
    };

    const handleNoShow = async (e, service) => {
        try {
            setIsLoading(true);
            let payload = {
                nResourceInstanceId: service.nResourceInstanceId,
                sNotes: "No Show"
            };


            const { data: _ignore_ } = await api
                .addESPNotes(payload)
                .then((d) => {
                    if (d.data) {
                        setIsLoading(false);
                        toast("Service Request handled successfully.", {
                            autoClose: 5000,
                            type: toast.TYPE.SUCCESS,
                        });
                        getExternalPartnerServices(tableInstance);
                    }
                })
                .catch((error) => {
                    setIsLoading(false);
                    toast(String(error.response.data.detail), {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                });
        }
        catch (error) {
            setIsLoading(false);
        }
    }

    const onRowSave = async (e, service) => {
        let result;
        let serviceResult;
        if (service === selectedServiceForEdit) {
            //setSelectedServiceForEdit();
            //setSelectedSecondServiceForEdit();  
            toast(`There are no unsaved changes to update service.`, {
                autoClose: 5000,
                type: toast.TYPE.INFO,
            });
        }
        else {
            if (service.custrefSRState != selectedServiceForEdit.custrefSRState ||
                selectedServiceForEdit.custsNotesHH ||
                service.custOtherServiceInfo != selectedServiceForEdit.custOtherServiceInfo ||
                service.custfGovtCharges != selectedServiceForEdit.custfGovtCharges ||
                service.custfAffiliateFees != selectedServiceForEdit.custfAffiliateFees ||
                service.custfProfessionalCharges != selectedServiceForEdit.custfProfessionalCharges ||
                service.custfTotalCharges != selectedServiceForEdit.custfTotalCharges ||
                service.custsCallStatus != selectedServiceForEdit.custsCallStatus ||
                service.custbNeedToTalkToSP != selectedServiceForEdit.custbNeedToTalkToSP ||
                service.custbOfflineMeet != selectedServiceForEdit.custbOfflineMeet
            ) {
                const selectedService = selectedServiceForEdit;

                if (selectedService.custrefSRState === "Refunded") {
                    openRefundModalIsTrue()
                }

                if (selectedService.custrefSRState === "Cancelled"
                    // || selectedService.custrefSRState === "Refunded"
                ) {
                    if (!selectedService.custsSRCancellationReason) {
                        toast(`Please select cancellation reason.`, {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                        return;
                    }
                    else {
                        if (selectedService.custsSRCancellationReason === "Other") {
                            if (!selectedService.custssSRCancellationReasonOtherDescription) {
                                toast(`Please specify cancellation reason.`, {
                                    autoClose: 5000,
                                    type: toast.TYPE.ERROR,
                                });
                                return;
                            }
                        }
                    }
                }

                if (service.custfGovtCharges != selectedService.custfGovtCharges ||
                    service.custfAffiliateFees != selectedService.custfAffiliateFees ||
                    service.custfProfessionalCharges != selectedService.custfProfessionalCharges ||
                    service.custfTotalCharges != selectedService.custfTotalCharges
                ) {
                    if (selectedService.custfGovtCharges ||
                        selectedService.custfAffiliateFees ||
                        selectedService.custfProfessionalCharges ||
                        selectedService.custfTotalCharges
                    ) {
                        if (!selectedService.custfGovtCharges) {
                            toast("Government charges is required.", {
                                autoClose: 5000,
                                type: toast.TYPE.ERROR,
                            });
                            return;
                        }

                        if (!selectedService.custfAffiliateFees) {
                            toast("Affiliate fees is required.", {
                                autoClose: 5000,
                                type: toast.TYPE.ERROR,
                            });
                            return;
                        }

                        if (!selectedService.custfProfessionalCharges) {
                            toast("Professional charges is required.", {
                                autoClose: 5000,
                                type: toast.TYPE.ERROR,
                            });
                            return;
                        }

                        if (!selectedService.custfTotalCharges) {
                            toast("Total charges is required.", {
                                autoClose: 5000,
                                type: toast.TYPE.ERROR,
                            });
                            return;
                        }

                        /*if(selectedService.custChargesid)
                        {
                            result=await UpdateEServicePartnerCharges(selectedService);
                        }
                        else
                        {
                            result=await AddEServicePartnerCharges(selectedService);
                        }*/
                    }
                    else {
                        //result=await UpdateEServicePartnerCharges(selectedService);
                    }
                }

                /*if(selectedService.serviceFrom=="LPM")
                {
                    if(selectedService.custsNotesHH||selectedService.custdtFollowupOn||selectedService.custsFollowupNotes)
                    {
                        if(!selectedService.custdtFollowupOn)
                        {
                            toast("Follow up on date is required.", {
                                autoClose: 5000,
                                type: toast.TYPE.ERROR,
                            });
                            return;
                        }

                        if(!selectedService.custsFollowupNotes)
                        {
                            toast("Follow up actions is required.", {
                                autoClose: 5000,
                                type: toast.TYPE.ERROR,
                            });
                            return;
                        }

                        if(!selectedService.custsNotesHH)
                        {
                            toast("Follow up notes is required.", {
                                autoClose: 5000,
                                type: toast.TYPE.ERROR,
                            });
                            return;
                        }
                    }

                    if(selectedService.custsNotesHH&&selectedService.custdtFollowupOn&&selectedService.custsFollowupNotes)
                    {
                        AddESPNotesLPM(selectedService);
                    }

                    
                }
                else
                {
                    if(selectedService.custsNotesHH||selectedService.custdtFollowupOn||selectedService.custsFollowupNotes)
                    {
                        if(!selectedService.custsNotesHH)
                        {
                            toast("Follow up notes is required.", {
                                autoClose: 5000,
                                type: toast.TYPE.ERROR,
                            });
                            return;
                        }
                        
                        if(selectedService.custsNotesHH)
                        {
                            AddESPNotesSPM(selectedService);
                        }
                    }
                }*/





                // let bOfflineMeetnew=selectedofflinemeetoptions.value;	
                // const { bOfflineMeet } = selectedServiceForEdit;
                // if(bOfflineMeetnew!=bOfflineMeet)
                // {
                // 	onUpdateOfflineMeetoptions();
                // }  




                // if(e.bOfflineMeet)
                // 	{
                // 		setselectedofflinemeetoptions({
                // 			value: true,
                // 			label: "Opted",
                // 		})
                // 	}
                // 	else
                // 	{
                // 		setselectedofflinemeetoptions({
                // 			value: false,
                // 			label: "Not Opted",
                // 		})
                // 	}





                if (selectedService.serviceFrom == "LPM") {
                    serviceResult = await CheckCurrentStatusOfServiceInLPM(selectedService);
                }
                else {
                    serviceResult = await CheckCurrentStatusOfServiceSPM(selectedService);
                }

                if (serviceResult) {
                    if (service.custrefSRState != selectedService.custrefSRState) {
                        if (selectedService.serviceFrom == "LPM") {
                            if (selectedService.custrefSRState == "Prepared" && service.sPaymentMode != "No_Payment") {
                                if (!service.nPackageInstanceId && service.sPaymentReceiver == "deAsra") {
                                    if (selectedService.fAmountFull === 0) {
                                        openConfirmationModalisTrue()
                                    } else {
                                        result = await handleSendPaymentLink(selectedService);
                                        result = await ChangeServiceStateLPM(selectedService);
                                    }
                                }else if (!service.nPackageInstanceId && service.sPaymentReceiver == "Partner" && service?.refExternalServicePartner == "Mr. Sudhir Gijare") {
                                    if (selectedService.fAmountFull === 0) {
                                        openConfirmationModalisTrue()
                                    } else {
                                        result = await handleSendPaymentLink(selectedService);
                                        result = await ChangeServiceStateLPM(selectedService);
                                    }
                                }else if(service.nPackageInstanceId && service.sPaymentReceiver == "Partner"){
                                     if (selectedService.fAmountFull === 0) {
                                        openConfirmationModalisTrue()
                                    } else {
                                        result = await handleSendPaymentLink(selectedService);
                                        result = await ChangeServiceStateLPM(selectedService);
                                    }
                                }
                                else {
                                    result = await ChangeServiceStateLPM(selectedService);
                                }
                            }
                            else {
                                result = await ChangeServiceStateLPM(selectedService);
                            }
                        }
                        else {
                            if (selectedService.custrefSRState != "Refunded") {
                                result = await ChangeServiceStateSPM(selectedService);
                            }

                        }
                    }

                    if (service.custfGovtCharges != selectedService.custfGovtCharges ||
                        service.custfAffiliateFees != selectedService.custfAffiliateFees ||
                        service.custfProfessionalCharges != selectedService.custfProfessionalCharges ||
                        service.custfTotalCharges != selectedService.custfTotalCharges
                    ) {
                        if (selectedService.custfGovtCharges &&
                            selectedService.custfAffiliateFees &&
                            selectedService.custfProfessionalCharges &&
                            selectedService.custfTotalCharges
                        ) {
                            if (selectedService.custChargesid) {
                                result = await UpdateEServicePartnerCharges(selectedService);
                            }
                            else {
                                result = await AddEServicePartnerCharges(selectedService);
                            }
                        }
                        else {
                            result = await UpdateEServicePartnerCharges(selectedService);
                        }
                    }

                    if (selectedService.custsNotesHH) {
                        result = await AddEServicePartnerNotes(selectedService);
                    }

                    if (service.custOtherServiceInfo != selectedService.custOtherServiceInfo) {
                        result = await UpdateOtherServiceInfo(selectedService);
                    }

                    if (service.custsCallStatus != selectedService.custsCallStatus) {
                        result = await UpdateCallStatus(selectedService);
                    }

                    if (service.custbOfflineMeet != selectedService.custbOfflineMeet) {
                        result = await UpdateOfflineMeet(selectedService);
                    }

                    if (service.custbNeedToTalkToSP != selectedService.custbNeedToTalkToSP) {
                        result = await UpdateNeedToTalkToSPStatus(selectedService);
                        /*if(selectedService.serviceFrom=="LPM")
                        {
                            result=await UpdateNeedToTalkToSPStatus(selectedService);
                        }
                        else
                        {
                            result=await onUpdateNeedToTalkToSPFlagSPM(selectedService);
                        }*/
                    }
                }
                else {
                    toast(`Service is already progressed. please try again after refreshing data.`, {
                        autoClose: 5000,
                        type: toast.TYPE.INFO,
                    });
                    getExternalPartnerServices(tableInstance);
                }
            }
            else {
                //setSelectedServiceForEdit();
                //setSelectedSecondServiceForEdit();  
                toast(`There are no unsaved changes to update service.`, {
                    autoClose: 5000,
                    type: toast.TYPE.INFO,
                });
            }
        }
    };

    const handleServiceRequestsNotesChange = (name, value) => {
        const floatRegExp = new RegExp('^([0-9]+([.][0-9]*)?|[.][0-9]+)$');
        if (name == "custfGovtCharges" || name == "custfAffiliateFees" || name == "custfProfessionalCharges" || name == "custfTotalCharges") {
            if (value != '' && floatRegExp.test(value) === false) {
                return;
            }
        }

        const updated = { ...selectedServiceForEdit, [name]: value };
        setSelectedServiceForEdit(updated);
        setactiveFocus(name);
    };

    const handleCursorPositionChange = (e) => {
        setcustsNotesHHCursorPosition({ selectionStart: e.target.selectionStart, selectionEnd: e.target.selectionEnd });
    };

    /* Service request update callbacks */
    let cancellation_Reason, OtherDescription;

    const ChangeServiceStateSPM = async (selectedService) => {

        let result;
        let data = { nResourceInstanceId: selectedService.nResourceInstanceId };
        let umcService = false;

        if (selectedService.sServiceCode === "MKTLINKAGEBULKBUYER" || selectedService.sServiceCode === "MKTLINKAGEECOM" || selectedService.sServiceCode === "MKTLINKAGECORPLINKAGE" ||
            selectedService.sServiceCode === "MKTLINKAGESHOPINSHOP" || selectedService.sServiceCode === "MKTLINKAGEEXHIBITION" || selectedService.sServiceCode === "MKTLINKAGEEXPORT") {
            umcService = true
        }


        try {
            setIsLoading(true);
            switch (selectedService.custrefSRState) {
                case "Service Delivery Started":
                    if (umcService) {
                        data = { ...data, bSendEmailNotificationToUser: 'N' };
                    }
                    result = await api.setServiceDeliveryStarted(data)
                        .then((d) => {
                            toast("Service updated successfully.", {
                                autoClose: 5000,
                                type: toast.TYPE.SUCCESS,
                            });
                            setIsLoading(false);
                            //setSelectedServiceForEdit();
                            //setSelectedSecondServiceForEdit();  
                            getExternalPartnerServices(tableInstance);
                        }).catch((error) => {
                            toast(String(error.response.data.detail), {
                                autoClose: 5000,
                                type: toast.TYPE.ERROR,
                            });
                            setIsLoading(false);
                        });

                    break;
                case "Payment Confirmed By Partner":
                    result = await api.setPaymentConfirmedbyPartner(data)
                        .then((response) => {
                            if (response.status == 202) {
                                if (response.data.message) {
                                    toast(response.data.message, {
                                        autoClose: 5000,
                                        type: toast.TYPE.SUCCESS,
                                    });
                                }
                                else {
                                    toast("Service updated successfully.", {
                                        autoClose: 5000,
                                        type: toast.TYPE.SUCCESS,
                                    });
                                }
                            }
                            else {
                                if (response.data.message) {
                                    toast(response.data.message, {
                                        autoClose: 5000,
                                        type: toast.TYPE.ERROR,
                                    });
                                }
                                else {
                                    toast("Internal server error.", {
                                        autoClose: 5000,
                                        type: toast.TYPE.ERROR,
                                    });
                                }
                            }
                            setIsLoading(false);
                            //setSelectedServiceForEdit();
                            //setSelectedSecondServiceForEdit();  
                            getExternalPartnerServices(tableInstance);
                        })
                        .catch((error) => {
                            if (error.response.data.message) {
                                toast(error.response.data.message, {
                                    autoClose: 5000,
                                    type: toast.TYPE.ERROR,
                                });
                            }
                            else {
                                toast(String(error.response.data.detail), {
                                    autoClose: 5000,
                                    type: toast.TYPE.ERROR,
                                });
                            }
                            setIsLoading(false);
                        });

                    break;
                case "Awaiting for information/Documents":
                    result = await api.setAwaitingForInformationDocuments(data)
                        .then((response) => {
                            if (response.status == 202) {
                                if (response.data.message) {
                                    toast(response.data.message, {
                                        autoClose: 5000,
                                        type: toast.TYPE.SUCCESS,
                                    });
                                }
                                else {
                                    toast("Service updated successfully.", {
                                        autoClose: 5000,
                                        type: toast.TYPE.SUCCESS,
                                    });
                                }
                            }
                            else {
                                if (response.data.message) {
                                    toast(response.data.message, {
                                        autoClose: 5000,
                                        type: toast.TYPE.ERROR,
                                    });
                                }
                                else {
                                    toast("Internal server error.", {
                                        autoClose: 5000,
                                        type: toast.TYPE.ERROR,
                                    });
                                }
                            }
                            setIsLoading(false);
                            //setSelectedServiceForEdit();
                            //setSelectedSecondServiceForEdit();  
                            getExternalPartnerServices(tableInstance);
                        })
                        .catch((error) => {
                            toast(String(error.response.data.detail), {
                                autoClose: 5000,
                                type: toast.TYPE.ERROR,
                            });
                            setIsLoading(false);
                        });

                    break;
                case "Service deliverables ready":
                    result = await api.setServiceDeliverablesReady(data)
                        .then((d) => {
                            console.log("ready==", d)
                            if (!d.data.nPackageInstanceId) {
                                if (d.data.sPaymentMode === "2_Step_Payment" && d.data.sPaymentReceiver === "deAsra") {
                                    sendPaymentLinkSPM(selectedService);
                                    // alert("Yes")
                                }else if (d.data.sPaymentMode === "2_Step_Payment" && d.data.sPaymentReceiver === "Partner" && d?.data?.refExternalServicePartner?.id == 66 ) {
                                    sendPaymentLinkSPM(selectedService);
                                    // alert("Yes")
                                }
                            }
                            // alert("NO")
                            toast("Service updated successfully.", {
                                autoClose: 5000,
                                type: toast.TYPE.SUCCESS,
                            });
                            setIsLoading(false);
                            //setSelectedServiceForEdit();
                            //setSelectedSecondServiceForEdit();  
                            getExternalPartnerServices(tableInstance);
                        })
                        .catch((error) => {
                            toast(String(error.response.data.message), {
                                autoClose: 5000,
                                type: toast.TYPE.ERROR,
                            });
                            setIsLoading(false);
                        });

                    break;
                case "Full Payment Requested":
                    result = await api.setFullPaymentRequested(data)
                        .then((d) => {
                            console.log(d)
                            toast("Service updated successfully.", {
                                autoClose: 5000,
                                type: toast.TYPE.SUCCESS,
                            });
                            setIsLoading(false);
                            //setSelectedServiceForEdit();
                            //setSelectedSecondServiceForEdit();  
                            getExternalPartnerServices(tableInstance);
                        })
                        .catch((error) => {
                            toast(String(error.response.data.message), {
                                autoClose: 5000,
                                type: toast.TYPE.ERROR,
                            });
                            setIsLoading(false);
                        });

                    break;
                case "Full Payment Received":
                    result = await api.setFullPaymentComplete(data)
                        .then((d) => {
                            toast("Service updated successfully.", {
                                autoClose: 5000,
                                type: toast.TYPE.SUCCESS,
                            });
                            setIsLoading(false);
                            //setSelectedServiceForEdit();
                            //setSelectedSecondServiceForEdit();  
                            getExternalPartnerServices(tableInstance);
                        })
                        .catch((error) => {
                            toast(String(error.response.data.message), {
                                autoClose: 5000,
                                type: toast.TYPE.ERROR,
                            });
                            setIsLoading(false);
                        });

                    break;
                case "Delivered":
                    if (umcService) {
                        data = { ...data, bSendEmailNotificationToUser: 'N' };
                    }
                    result = await api.setServiceDelivered(data)
                        .then((d) => {
                            toast("Service updated successfully.", {
                                autoClose: 5000,
                                type: toast.TYPE.SUCCESS,
                            });
                            setIsLoading(false);
                            //setSelectedServiceForEdit();
                            //setSelectedSecondServiceForEdit();  
                            getExternalPartnerServices(tableInstance);
                        })
                        .catch((error) => {
                            toast(String(error.response.data.detail), {
                                autoClose: 5000,
                                type: toast.TYPE.ERROR,
                            });
                            setIsLoading(false);
                        });

                    break;
                case "Refunded":
                    // openRefundModalIsTrue()

                    if (selectedService.custsSRCancellationReason) {
                        cancellation_Reason = selectedService.custsSRCancellationReason;
                        if (cancellation_Reason !== "Other") {
                            OtherDescription = null;
                        }
                        else {
                            OtherDescription = selectedService.custssSRCancellationReasonOtherDescription;
                        }
                    }

                    result = await api.setServiceCancelled({
                        ...data,
                        cancellationReason: cancellation_Reason,
                        cancellationReasonOtherDescription: OtherDescription,
                    })
                        .then((d) => {
                            toast("Service updated successfully.", {
                                autoClose: 5000,
                                type: toast.TYPE.SUCCESS,
                            });
                            setIsLoading(false);
                            //setSelectedServiceForEdit();
                            //setSelectedSecondServiceForEdit();  
                            getExternalPartnerServices(tableInstance);
                        })
                        .catch((error) => {
                            toast(String(error.response.data.detail), {
                                autoClose: 5000,
                                type: toast.TYPE.ERROR,
                            });
                            setIsLoading(false);
                        });

                    break;
                case "Cancelled":
                    // let cancellation_Reason, OtherDescription;
                    if (selectedService.custsSRCancellationReason) {
                        cancellation_Reason = selectedService.custsSRCancellationReason;
                        if (cancellation_Reason !== "Other") {
                            OtherDescription = null;
                        }
                        else {
                            OtherDescription = selectedService.custssSRCancellationReasonOtherDescription;
                        }
                    }

                    let cancelPayload = {
                        ...data,
                        cancellationReason: cancellation_Reason,
                        cancellationReasonOtherDescription: OtherDescription,
                    };

                    if (umcService) {
                        cancelPayload = { ...cancelPayload, bSendEmailNotificationToUser: 'N' };
                    }

                    result = await api.setServiceCancelled(cancelPayload)
                        .then((d) => {
                            toast("Service updated successfully.", {
                                autoClose: 5000,
                                type: toast.TYPE.SUCCESS,
                            });
                            setIsLoading(false);
                            //setSelectedServiceForEdit();
                            //setSelectedSecondServiceForEdit();  
                            getExternalPartnerServices(tableInstance);
                        })
                        .catch((error) => {
                            toast(String(error.response.data.detail), {
                                autoClose: 5000,
                                type: toast.TYPE.ERROR,
                            });
                            setIsLoading(false);
                        });

                    break;
                default:
                    break;
            }
        }
        catch (error) {
            toast(String(error.response.data.detail), {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
            setIsLoading(false);
        }
    };

    const ChangeServiceStateLPM = async (selectedService) => {
        const {
            nResourceInstanceId,
            custrefSRState
        } = selectedService;
        let cancellation_Reason, OtherDescription;
        if (selectedService.custsSRCancellationReason) {
            cancellation_Reason = selectedService.custsSRCancellationReason;
            if (cancellation_Reason !== "Other") {
                OtherDescription = null;
            }
            else {
                OtherDescription = selectedService.custssSRCancellationReasonOtherDescription;
            }
        }
        const payload = {
            nResourceInstanceId,
            sSRState: custrefSRState,
            cancellationReason: cancellation_Reason,
            cancellationReasonOtherDescription: OtherDescription,
        };
        var s = payload;
        // eslint-disable-next-line no-unused-vars
        const isSudhirPartner =
            selectedService?.refExternalServicePartner === "Mr. Sudhir Gijare" ||
            selectedService?.ext_sp_org === "Mr. Sudhir Gijare";

        const isValidPackage =
            (
                selectedService?.nPackageInstanceId === null &&
                isSudhirPartner
            ) ||
            (
                selectedService?.nPackageInstanceId !== null &&
                (
                    (selectedService?.sPackageOfferTitle !== "Long Term Engagement Package" || selectedService?.sPackageOfferTitle !== "Long Term Engagement Package1") ||
                    isSudhirPartner
                )
            );

        if (
            selectedService?.sPaymentReceiver === "Partner" &&
            custrefSRState === "Payment Received" &&
            isValidPackage
        ) {
            try {
                const response = await api.getServiceDetailsLPMByInstanceID(
                    selectedService?.nResourceInstanceId
                );

                const serviceDetails = response?.data;

                const isPaymentAvailable =
                    serviceDetails?.sPaymentStatus === "Payment Link Deactivated" ||
                    serviceDetails?.sPaymentStatus === "Credit" ||
                    !!serviceDetails?.sNEFTDetails ||
                    !!serviceDetails?.sNEFTTxnId_1 ||
                    serviceDetails?.bNEFTPayment === true;

                if (!isPaymentAvailable) {
                    toast(`NEFT Id or Instamojo Id should be available.`, {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                    return;
                }
            } catch (error) {
                console.log('error::::',error)
                toast("Unable to verify payment details.", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
                return;
            }
        }
        try {
            setIsLoading(true);
            const { data: _ignore_ } = await api
                .changeServiceRequestState(payload)
                .then((d) => {
                    if (d.data) {
                        setIsLoading(false);
                        if (d.data["SR"]["refSRState"] === "Cancelled") {
                            toast(`Service request cancelled successfully.`, {
                                autoClose: 5000,
                                type: toast.TYPE.SUCCESS,
                            });
                        }
                        else {
                            toast(`Service request updated successfully.`, {
                                autoClose: 5000,
                                type: toast.TYPE.SUCCESS,
                            });
                        }
                        //setSelectedServiceForEdit();
                        //setSelectedSecondServiceForEdit();  
                        getExternalPartnerServices(tableInstance);
                    }
                })
                .catch((error) => {
                    setIsLoading(false);
                    if (error.response.data.detail) {
                        toast(String(error.response.data.detail), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    }
                    else if (error.response.data.message) {
                        toast(String(error.response.data.message), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    }
                    else {
                        toast("Internal server error", {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    }

                });
        }
        catch (error) {
            setIsLoading(false);
        }
    }

    const AddESPNotesLPM = async (selectedService) => {
        try {
            setIsLoading(true);
            const
                {
                    nResourceInstanceId,
                    custsNotesHH,
                    custdtFollowupOn,
                    custsFollowupNotes
                } = selectedService;
            const payload =
            {
                nResourceInstanceId,
                sNotes: "Partner: " + custsNotesHH,
                //dtFollowupOn:custdtFollowupOn.toISOString(),
                //sFollowupNotes:"Partner: "+custsFollowupNotes
            };

            var s = payload;

            const { data: _ignore_ } = await api
                .updateServiceRequest(payload)
                .then((d) => {
                    if (d.data) {
                        setIsLoading(false);
                        toast("Service request handled successfully.", {
                            autoClose: 5000,
                            type: toast.TYPE.SUCCESS,
                        });
                        setSelectedServiceForEdit();
                        setSelectedSecondServiceForEdit();
                        getExternalPartnerServices(tableInstance);
                    }
                })
                .catch((error) => {
                    setIsLoading(false);
                    toast(String(error.response.data.detail), {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                });
        }
        catch (error) {
            setIsLoading(false);
        }
    };

    function getFutureDate(days) {
        var result = new Date();
        result.setDate(result.getDate() + days);
        return result.toISOString();
    }

    const AddESPNotesSPM = async (selectedService) => {
        try {
            setIsLoading(true);
            const {
                nResourceInstanceId,
                custsNotesHH,
                custdtFollowupOn,
                custsFollowupNotes
            } = selectedService;

            var dtFollowupOn = null;
            if (custdtFollowupOn) {
                dtFollowupOn = custdtFollowupOn.toISOString();
            }

            const payload = {
                nResourceInstanceId,
                sNotes: custsNotesHH,
                //dtFollowupOn:dtFollowupOn,
                //sFollowupAction:"Partner: "+custsFollowupNotes
            };

            const { data: _ignore_ } = await api
                .saveNotes(payload)
                .then((d) => {
                    if (d.data) {
                        setIsLoading(false);
                        toast("Service Request handled successfully.", {
                            autoClose: 5000,
                            type: toast.TYPE.SUCCESS,
                        });
                        setSelectedServiceForEdit();
                        setSelectedSecondServiceForEdit();
                        getExternalPartnerServices(tableInstance);
                    }
                })
                .catch((error) => {
                    setIsLoading(false);
                    toast(String(error.response.data.detail), {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                });
        }
        catch (error) {
            setIsLoading(false);
        }
    };

    const AddEServicePartnerNotes = async (selectedService) => {
        try {
            setIsLoading(true);
            const {
                nResourceInstanceId,
                custsNotesHH,
                custsUpdateNoteForAllServicesInPackage
            } = selectedService;

            let payload = {
                nResourceInstanceId,
                sNotes: custsNotesHH
            };

            if (custsUpdateNoteForAllServicesInPackage) {
                payload.update_all_services = "True";
            }

            const { data: _ignore_ } = await api
                .addESPNotes(payload)
                .then((d) => {
                    if (d.data) {
                        setIsLoading(false);
                        toast("Service Request handled successfully.", {
                            autoClose: 5000,
                            type: toast.TYPE.SUCCESS,
                        });
                        //setSelectedServiceForEdit();
                        //setSelectedSecondServiceForEdit();  
                        getExternalPartnerServices(tableInstance);
                    }
                })
                .catch((error) => {
                    setIsLoading(false);
                    toast(String(error.response.data.detail), {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                });
        }
        catch (error) {
            setIsLoading(false);
        }
    };

    const UpdateOtherServiceInfo = async (selectedService) => {
        try {

            const {
                nResourceInstanceId,
                custOtherServiceInfo
            } = selectedService;

            var sOtherServicesInfo = null;
            if (custOtherServiceInfo) {
                sOtherServicesInfo = custOtherServiceInfo;
            }

            const payload = {
                nResourceInstanceId,
                sOtherServicesInfo: sOtherServicesInfo,
            };
            setIsLoading(true);
            const { data: _ignore_ } = await api
                .updateOtherServiceInfo(payload)
                .then((d) => {
                    if (d.data) {
                        setIsLoading(false);
                        toast("Service Request handled successfully.", {
                            autoClose: 5000,
                            type: toast.TYPE.SUCCESS,
                        });
                        //setSelectedServiceForEdit();
                        //setSelectedSecondServiceForEdit();  
                        getExternalPartnerServices(tableInstance);
                    }
                })
                .catch((error) => {
                    setIsLoading(false);
                    toast(String(error.response.data.detail), {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                });
        }
        catch (error) {
            setIsLoading(false);
        }
    };

    const UpdateCallStatus = async (selectedService) => {
        try {

            const {
                nResourceInstanceId,
                custsCallStatus
            } = selectedService;

            var sCallStatus = null;
            if (custsCallStatus) {
                sCallStatus = custsCallStatus;
            }

            const payload = {
                nResourceInstanceId,
                sCallStatus: sCallStatus,
            };
            setIsLoading(true);
            const { data: _ignore_ } = await api
                .updateCallStatus(payload)
                .then((d) => {
                    if (d.data) {
                        setIsLoading(false);
                        toast("Call status updated successfully.", {
                            autoClose: 5000,
                            type: toast.TYPE.SUCCESS,
                        });
                        //setSelectedServiceForEdit();
                        //setSelectedSecondServiceForEdit();  
                        getExternalPartnerServices(tableInstance);
                    }
                })
                .catch((error) => {
                    setIsLoading(false);
                    toast(String(error.response.data.detail), {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                });
        }
        catch (error) {
            setIsLoading(false);
        }
    };


    const UpdateOfflineMeet = async (selectedService) => {
        try {

            const {
                nResourceInstanceId,
                custbOfflineMeet
            } = selectedService;

            var bOfflineMeet = null;
            if (custbOfflineMeet) {
                bOfflineMeet = custbOfflineMeet;
            }

            const payload = {
                nResourceInstanceId,
                bOfflineMeet: bOfflineMeet,
            };
            setIsLoading(true);
            const { data: _ignore_ } = await api
                .updateOfflineMeet(payload)
                .then((d) => {
                    if (d.data) {
                        setIsLoading(false);
                        toast("Offline meet status updated successfully.", {
                            autoClose: 5000,
                            type: toast.TYPE.SUCCESS,
                        });
                        //setSelectedServiceForEdit();
                        //setSelectedSecondServiceForEdit();  
                        getExternalPartnerServices(tableInstance);
                    }
                })
                .catch((error) => {
                    setIsLoading(false);
                    toast(String(error.response.data.detail), {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                });
        }
        catch (error) {
            setIsLoading(false);
        }
    };

    const UpdateNeedToTalkToSPStatus = async (selectedService) => {
        try {

            const {
                nResourceInstanceId,
                custbNeedToTalkToSP
            } = selectedService;

            var bNeedToTalkToSP = false;
            if (custbNeedToTalkToSP) {
                bNeedToTalkToSP = custbNeedToTalkToSP;
            }
            const payload = {
                nResourceInstanceId,
                bNeedToTalkToSP: bNeedToTalkToSP,
            };
            setIsLoading(true);
            const { data: _ignore_ } = await api
                .updateNeedToTalkToSPFlagFromSPLed(payload)
                .then((d) => {
                    if (d.data) {
                        setIsLoading(false);
                        toast("Need to talk to SP status updated successfully.", {
                            autoClose: 5000,
                            type: toast.TYPE.SUCCESS,
                        });
                        //setSelectedServiceForEdit();
                        //setSelectedSecondServiceForEdit();  
                        getExternalPartnerServices(tableInstance);
                    }
                })
                .catch((error) => {
                    setIsLoading(false);
                    toast(String(error.response.data.detail), {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                });
        }
        catch (error) {
            setIsLoading(false);
        }
    };

    /*Need to talk to sp callback */
    const onUpdateNeedToTalkToSPFlagSPM = async (selectedService) => {
        try {
            const {
                nResourceInstanceId,
                custbNeedToTalkToSP
            } = selectedService;

            var bNeedToTalkToSP = false;
            if (custbNeedToTalkToSP) {
                bNeedToTalkToSP = custbNeedToTalkToSP;
            }
            setIsLoading(true);
            const { data: _ignore_ } = await api
                .updateNeedtoTalkToSPFlagSPM(nResourceInstanceId, { bNeedToTalkToSP })
                .then((response) => {
                    if (response.status == 202) {
                        setIsLoading(false);
                        //setSelectedServiceForEdit();
                        //setSelectedSecondServiceForEdit();  
                        getExternalPartnerServices(tableInstance);
                        if (response.data.message) {
                            toast(response.data.message, {
                                autoClose: 5000,
                                type: toast.TYPE.SUCCESS,
                            });
                        }
                        else {
                            toast("Need to talk to SP status updated successfully.", {
                                autoClose: 5000,
                                type: toast.TYPE.SUCCESS,
                            });
                        }
                    }
                    else {
                        if (response.data.message) {
                            toast(response.data.message, {
                                autoClose: 5000,
                                type: toast.TYPE.ERROR,
                            });
                        }
                        else {
                            toast("Internal server error.", {
                                autoClose: 5000,
                                type: toast.TYPE.ERROR,
                            });
                        }
                    }
                    //toggleNotesModal();
                    //getServices(tableInstance);				
                })
                .catch((error) => {
                    toast(String(error.response.data.message), {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                });
        }
        catch (error) {
            setIsLoading(false);
        }

    };
    /*end*/

    const handleSendPaymentLink = async (selectedService) => {
        try {
            setIsLoading(true);
            const { nResourceInstanceId } = selectedService;

            const {
                data: { message },
            } = await api.sendPaymentLink({ nResourceInstanceId });

            const { status, message: serverMessage } = message;
            if (status === "success") {
                const payload = {
                    nResourceInstanceId,
                    sSRState: "Partial/ Full Payment Pending",
                };
                // eslint-disable-next-line no-unused-vars
                const { data: _ignore_ } = await api.changeServiceRequestState(
                    payload
                );
                //setSelectedServiceForEdit();
                //setSelectedSecondServiceForEdit();  
                getExternalPartnerServices(tableInstance);
                toast(`Payment link sent successfully.`, {
                    autoClose: 5000,
                    type: toast.TYPE.SUCCESS,
                });
            }else if (status === "error" && serverMessage === "Updating LS record failed" || serverMessage === "Payment link is active. But, error in updating details to LS" || serverMessage === "'data'") {
				const payload = {
					nResourceInstanceId,
					sSRState: "Partial/ Full Payment Pending",
				};
				// eslint-disable-next-line no-unused-vars
				 const { data: _ignore_ } = await api.changeServiceRequestState(
                    payload
                );
                //setSelectedServiceForEdit();
                //setSelectedSecondServiceForEdit();  
                getExternalPartnerServices(tableInstance);
				toast(`Payment link sent successfully.`, {
					autoClose: 5000,
					type: toast.TYPE.SUCCESS,
				});
			}
            else {
                toast(`${message.message}`, {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
                //show error and message
            }
        }
        catch (error) {
            toast(`Something went wrong.Contact webadmin support.`, {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
        } finally {
            setIsLoading(false);
        }
    };

    const sendPaymentLinkSPM = (selectedService) => {

        try {
            setIsLoading(true);
            const { nResourceInstanceId } = selectedService;
            let data = api.sendPaymentLinkSPM({ nResourceInstanceId: nResourceInstanceId })
                .then((d) => {
                    if (d.data.message.status_code === "0") {
                        api.setFullPaymentRequested({
                            nResourceInstanceId: nResourceInstanceId,
                        })
                            .then(() => {
                                toast("Payment link sent successfully", {
                                    autoClose: 5000,
                                    type: toast.TYPE.SUCCESS,
                                });
                                setIsLoading(false);
                                //setSelectedServiceForEdit();
                                //setSelectedSecondServiceForEdit();  
                                getExternalPartnerServices(tableInstance);
                            })
                            .catch((error) => {
                                toast(String(error.response.data.message), {
                                    autoClose: 5000,
                                    type: toast.TYPE.ERROR,
                                });
                                setIsLoading(false);
                            });

                        // toast("Payment link sent successfully", {
                        //     autoClose: 5000,
                        //     type: toast.TYPE.SUCCESS,
                        // });
                        // setIsLoading(false);
                    } else if (d.data.message.status === "error" && d.data.message.message === "Updating LS record failed" || d.data.message.message === "Payment link is active. But, error in updating details to LS" || d.data.message.message === "'data'") {
                        api.setFullPaymentRequested({
                            nResourceInstanceId: nResourceInstanceId,
                        })
                            .then(() => {
                                toast("Payment link sent successfully", {
                                    autoClose: 5000,
                                    type: toast.TYPE.SUCCESS,
                                });
                                setIsLoading(false);
                                //setSelectedServiceForEdit();
                                //setSelectedSecondServiceForEdit();  
                                getExternalPartnerServices(tableInstance);
                            })
                            .catch((error) => {
                                toast(String(error.response.data.message), {
                                    autoClose: 5000,
                                    type: toast.TYPE.ERROR,
                                });
                                setIsLoading(false);
                            });
                    }else {
                        toast(String(d.data.message.message), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                        setIsLoading(false);
                    }
                })
                .catch((error) => {
                    toast(String(error.response.data.detail), {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                    setIsLoading(true);
                });
        }
        catch (error) {
            setIsLoading(false);
        }
    };

    const AddEServicePartnerCharges = async (selectedService) => {
        try {
            const {
                nResourceInstanceId,
                custfGovtCharges,
                custfAffiliateFees,
                custfProfessionalCharges,
                custfTotalCharges
            } = selectedService;

            const payload = {
                nResourceInstanceId,
                fGovtCharges: parseFloat(custfGovtCharges),
                fAffiliateFees: parseFloat(custfAffiliateFees),
                fProfessionalCharges: parseFloat(custfProfessionalCharges),
                fTotalCharges: parseFloat(custfTotalCharges)
            };
            setIsLoading(true);
            const { data: _ignore_ } = await api
                .addESPServiceCharges(payload)
                .then((d) => {
                    if (d.data) {
                        setIsLoading(false);
                        toast("Service Request charges added successfully.", {
                            autoClose: 5000,
                            type: toast.TYPE.SUCCESS,
                        });
                        //setSelectedServiceForEdit();
                        //setSelectedSecondServiceForEdit();  
                        getExternalPartnerServices(tableInstance);
                    }
                })
                .catch((error) => {
                    setIsLoading(false);
                    toast(String(error.response.data.detail), {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                });
        }
        catch (error) {
            setIsLoading(false);
        }
    };

    const UpdateEServicePartnerCharges = async (selectedService) => {
        try {
            const {
                nResourceInstanceId,
                custfGovtCharges,
                custfAffiliateFees,
                custfProfessionalCharges,
                custfTotalCharges,
                custChargesid
            } = selectedService;

            const payload = {
                nResourceInstanceId,
                fGovtCharges: custfGovtCharges ? parseFloat(custfGovtCharges) : null,
                fAffiliateFees: custfAffiliateFees ? parseFloat(custfAffiliateFees) : null,
                fProfessionalCharges: custfProfessionalCharges ? parseFloat(custfProfessionalCharges) : null,
                fTotalCharges: custfTotalCharges ? parseFloat(custfTotalCharges) : null
            };
            setIsLoading(true);
            const { data: _ignore_ } = await api
                .updateESPServiceCharges(custChargesid, payload)
                .then((d) => {
                    if (d.data) {
                        setIsLoading(false);
                        toast("Service Request charges updated successfully.", {
                            autoClose: 5000,
                            type: toast.TYPE.SUCCESS,
                        });
                        //setSelectedServiceForEdit();
                        //setSelectedSecondServiceForEdit();  
                        getExternalPartnerServices(tableInstance);
                    }
                })
                .catch((error) => {
                    setIsLoading(false);
                    toast(String(error.response.data.detail), {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                });
        }
        catch (error) {
            setIsLoading(false);
        }
    };

    const UpdateNewNotesFlag = async (nResourceInstanceId) => {
        try {
            const payload = {
                nResourceInstanceId,
                bNewNotesAdded: false,
            };
            setIsLoading(true);
            const { data: _ignore_ } = await api
                .updateNewNotesFlag(payload)
                .then((d) => {
                    if (d.data) {
                        setIsLoading(false);
                        toast("Notes flag updated successfully.", {
                            autoClose: 5000,
                            type: toast.TYPE.SUCCESS,
                        });
                        //setSelectedServiceForEdit();
                        //setSelectedSecondServiceForEdit();  
                        getExternalPartnerServices(tableInstance);
                    }
                })
                .catch((error) => {
                    setIsLoading(false);
                    toast(String(error.response.data.detail), {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                });
        }
        catch (error) {
            setIsLoading(false);
        }
    };

    const CheckCurrentStatusOfServiceInLPM = async (selectedService) => {
        try {
            const { nResourceInstanceId } = selectedService;
            const payload = { nResourceInstanceId };
            setIsLoading(true);
            let result = await api
                .getServiceDetailsLPMByInstanceID(nResourceInstanceId)
                .then((d) => {
                    if (d.data) {
                        setIsLoading(false);
                        if (selectedService.refSRState === d.data.refSRState) {
                            return true;
                        }
                        else {
                            return false;
                        }
                    }
                    else {
                        return false;
                    }
                })
                .catch((error) => {
                    setIsLoading(false);
                    return false;
                    toast(String(error.response.data.detail), {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                });

            return result;
        }
        catch (error) {
            setIsLoading(false);
            return false;
        }
    };

    const CheckCurrentStatusOfServiceSPM = async (selectedService) => {
        try {
            const { nResourceInstanceId } = selectedService;
            const payload = { nResourceInstanceId };
            setIsLoading(true);
            let result = await api
                .getServiceDetailsSPMByInstanceID(nResourceInstanceId)
                .then((d) => {
                    if (d.data) {
                        setIsLoading(false);
                        if (selectedService.refCurrentState.sServiceState === d.data.refCurrentState.sServiceState) {
                            return true;
                        }
                        else {
                            return false;
                        }

                    }
                    else {
                        return false;
                    }
                })
                .catch((error) => {
                    setIsLoading(false);
                    return false;
                    toast(String(error.response.data.detail), {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                });
            return result;
        }
        catch (error) {
            setIsLoading(false);
            return false;
        }
    };

    /* Service request update callbacks end*/

    /*Callbacks for service filter */
    const toggleAllForFilter = () => {
        let temp = [];

        if (selectedServiceNameListForFilter.length != serviceNameListForFilter.length && selectedServiceNameListForFilter.length != (serviceNameListForFilter.length + 1)) {
            if (selectedServiceNameListForFilter.includes({ label: "All", value: "*" })) {
                temp = selectedServiceNameListForFilter;
            }
            else {
                temp = [{ label: "All", value: "*" }];
            }

            let tempSR = serviceNameListForFilter.map((e) => {
                if (!temp.includes(e)) {
                    temp = temp.concat(e);
                }
                return e;
            });
            setSelectedServiceNameListForFilter(temp);
            setServiceNameListForFilter(tempSR);
            //getExternalPartnerServices(tableInstance);
        }
        else {
            setSelectedServiceNameListForFilter([]);
            //getExternalPartnerServices(tableInstance);
        }
    };

    const toggleSelectionForFilter = (e) => {
        setSelectedServiceNameListForFilter(e);
    };

    const toggleAllForServiceStatusFilter = () => {
        let temp = [];

        if (selectedServiceStatusListForFilter.length != serviceStatusNameListForFilter.length && selectedServiceStatusListForFilter.length != (serviceStatusNameListForFilter.length + 1)) {
            if (selectedServiceStatusListForFilter.includes({ label: "All", value: "*" })) {
                temp = selectedServiceStatusListForFilter;
            }
            else {
                temp = [{ label: "All", value: "*" }];
            }

            let tempSR = serviceStatusNameListForFilter.map((e) => {
                if (!temp.includes(e)) {
                    temp = temp.concat(e);
                }
                return e;
            });
            setSelectedServiceStatusListForFilter(temp);
            setServiceStatusNameListForFilter(tempSR);
            //getExternalPartnerServices(tableInstance);
        }
        else {
            setSelectedServiceStatusListForFilter([]);
            //getExternalPartnerServices(tableInstance);
        }
    };

    const toggleSelectionForServiceStatusFilter = (e) => {
        setSelectedServiceStatusListForFilter(e);
    };


    const handleSearchClick = async () => {
        if (showFilterModal) {
            toggleFilterModal();
        }
        setSelectedServiceForEdit();
        setSelectedSecondServiceForEdit();
        setExpandedChange({});
        // if(confirmationChecked){
        //      getFilterDataExternalService(tableInstance, true)
        // } else {
            getExternalPartnerServices(tableInstance, true);
        // }
        
        //refreshTable();
    };

    const handleClearFilterSearch = () => {
        let tempStatus = serviceStatusList.map((x) => {
            x.checked = false;
            return x;
        });
        setSelectedServiceNameListForFilter([]);
        setSelectedServiceStatus([]);
        setServiceStatusList(tempStatus);
        setSearchTerm("");
        setfromDate("");
        settoDate("");
        setSelectedRequestedaCallBackOption(null/*{
            value: "all",
            label: "All",
        }*/);
        setSelectedNeedToTalkToSPOption(null/*{
            value: "all",
            label: "All",
        }*/);
        setSelectedRequestedByOption(null/*{
            value: "all",
            label: "All",
        }*/);
        setselectedCallStatusOptionForFilter(null/*{
            value: "all",
            label: "All",
        }*/);
        setselectedofflinemeetoptionsForFilter(null);

        setSelectedPackageNameListForFilter(null);
        // setselectedofflinemeetoptions(null);
        //setExpandedChange({});
        setSelectedServiceStatusListForFilter([]);
        setRequestWithinTAT('');
    };

    const toggleServiceStatus = (e) => {
        let temp = selectedServiceStatus;

        if (!temp.includes(e)) {
            temp = temp.concat(e);
            let tempStatus = serviceStatusList.map((x) => {
                if (x.id == e) {
                    x.checked = true;
                }
                return x;
            });
            alert(tempStatus)
            setServiceStatusList(tempStatus);
            setSelectedServiceStatus(temp);
        } else {
            let idx = temp.indexOf(e);
            temp.splice(idx, 1);
            let tempStatus = serviceStatusList.map((x) => {
                if (x.id == e) {
                    x.checked = false;
                }
                return x;
            });
            setServiceStatusList(tempStatus);
            setSelectedServiceStatus(temp);
            //getExternalPartnerServices(tableInstance);
        }
    };

    const ondePreneurDetailsUpdate = () => {
        onBusinessDetailsUpdate();
        onBusinessVerifyUpdate();
    }

    const handleSearchInputChange = ({ target }) => {
        const { value, name } = target;
        setSearchTerm(value);
        setactiveFocus(name);
    };

    const onBusinessDetailsChange = (name, value) => {
        if (name === "sBusinessDescription") {
            if (value.length <= 300) {
                let updated = { ...selectedServiceRequestBusinessDetailsForEdit, [name]: value }
                setselectedServiceRequestBusinessDetailsForEdit(updated);
            }
            else {
                toast("Description should have maximum 300 characters.", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
                return;
            }
        }
        else {
            let updated = { ...selectedServiceRequestBusinessDetailsForEdit, [name]: value }
            setselectedServiceRequestBusinessDetailsForEdit(updated);
        }
    }

    const onBusinessDetailsUpdate = async () => {
        if (selectedServiceRequestBusinessDetailsForEdit) {
            const
                {
                    sBusinessName,
                    sBusinessDescription,
                    resource_instance_id
                } = selectedServiceRequestBusinessDetailsForEdit;

            if (!sBusinessName) {
                toast("Business Name is required", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
                return;
            }

            /*if(!sBusinessDescription)
            {
                toast("Business Description is required", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
                return;
            }*/

            /*if(!sBusinessDescription&&sBusinessDescription.length<=300)
            {
                toast("Description should have maximum 300 characters.", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
                return;
            }*/

            try {
                const payload = {
                    sBusinessName,
                    //sBusinessDescription,
                    resource_instance_id
                };
                setIsLoading(true);
                const { data: _ignore_ } = await api.updatedePrenuerBusinessData(payload)
                    .then((d) => {
                        if (d.data.Message) {
                            setIsLoading(false);
                            toast(d.data.Message, {
                                autoClose: 5000,
                                type: toast.TYPE.SUCCESS,
                            });
                            handleViewdePreneurDetailsModal();
                            //setSelectedServiceForEdit();
                            //setSelectedSecondServiceForEdit();  
                            getExternalPartnerServices(tableInstance);
                        }
                    })
                    .catch((error) => {
                        setIsLoading(false);
                        toast(String(error.response.data.detail), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    });
            }
            catch (error) {
                setIsLoading(false);
            }
        }
        else {
            toast("Please enter details.", {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
            return;
        }
    }

    const onBusinessVerifyUpdate = async () => {
        try {
            const
                {
                    is_business_verified,
                    resource_instance_id
                } = selectedServiceRequestBusinessDetailsForEdit;

            let isVerified = 'No';
            if (is_business_verified === 'Yes') {
                isVerified = 'Yes';
            }

            const payload = {
                resource_instance_id,
                is_business_verified: isVerified
            };
            setIsLoading(true);
            const { data: _ignore_ } = await api
                .updatedePrenuerServiceVerifiedFlag(payload)
                .then((d) => {
                    if (d.data) {
                        setIsLoading(false);
                        toast(d.data.Message, {
                            autoClose: 5000,
                            type: toast.TYPE.SUCCESS,
                        });
                        handleViewdePreneurDetailsModal();
                        //setSelectedServiceForEdit();
                        //setSelectedSecondServiceForEdit();  
                        getExternalPartnerServices(tableInstance);
                    }
                })
                .catch((error) => {
                    setIsLoading(false);
                    toast(String(error.response.data.detail), {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                });
        }
        catch (error) {
            setIsLoading(false);
        }
    }

    const changePage = (pageIndex) => {
        setcurrentPage(pageIndex);
    }

    /* Callbacks for service filter */

    const adjustedToDate = (date) => {
        let toDateAdjusted;
        if (date) {
            toDateAdjusted = new Date(date);

            toDateAdjusted = new Date(
                toDateAdjusted.setTime(
                    toDateAdjusted.getTime() + 24 * 60 * 60 * 1000 - 1000
                )
            );
        }
        return toDateAdjusted;
    };

    const handleReportsClick = async () => {
        toggleReportsModal();
        setASPfromDate("");
        setASPtoDate("");
        setSRFfromDate("");
        setSRFtoDate("");
    };

    const fetchFullfillmentReport = () => {
        /*if(!SRFfromDate)
        {
            toast("From date is required.", {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
            return;
        }

        if(!SRFtoDate)
        {
            toast("To date is required.", {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
            return;
        }*/
        setIsLoadingReports(true);
        try {
            api.getFullfillmentReport({
                fromDate: SRFfromDate,
                toDate: adjustedToDate(SRFtoDate),
                role: 'extSP'
            })
                .then(({ data }) => {
                    toast(data["details"], {
                        autoClose: 5000,
                        type: toast.TYPE.SUCCESS,
                    });
                    window.open(data["generated_file"], "_self");
                    setIsLoadingReports(false);
                })
                .catch((error) => {
                    setIsLoadingReports(false);
                    toast(error["response"]["data"]["message"], {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                });
        } catch {
            setIsLoadingReports(false);
            toast("Server error.", {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
        }
    };

    const fetchAllServicesReport = () => {
        /*if(!ASPfromDate)
        {
            toast("From date is required.", {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
            return;
        }

        if(!ASPtoDate)
        {
            toast("To date is required.", {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
            return;
        }*/
        setIsLoadingReports(true);
        try {
            api.getAllServicesReport({
                fromDate: ASPfromDate,
                toDate: adjustedToDate(ASPtoDate),
                role: 'extSP'
            })
                .then(({ data }) => {
                    toast(data["details"], {
                        autoClose: 5000,
                        type: toast.TYPE.SUCCESS,
                    });
                    window.open(data["generated_file"], "_self");
                    setIsLoadingReports(false);
                })
                .catch((error) => {
                    console.log(error.status);
                    setIsLoadingReports(false);
                    toast(error["response"]["data"]["message"], {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                });
        } catch {
            setIsLoadingReports(false);
            toast("Server error.", {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
        }
    };

    const fetchSMSTrailReport = () => {
        setIsLoadingReports(true);
        try {
            api.getSMSTrailReport()
                .then(({ data }) => {
                    toast(data["details"], {
                        autoClose: 5000,
                        type: toast.TYPE.SUCCESS,
                    });
                    window.open(data["generated_file"], "_self");
                    setIsLoadingReports(false);
                })
                .catch((error) => {
                    setIsLoadingReports(false);
                    toast(error["response"]["data"]["message"], {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                });
        } catch {
            setIsLoadingReports(false);
            toast("Server error.", {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
        }
    };

    const handleSendSMSClick = async (selectedService) => {
        setSelectedServiceForSendSMS(selectedService);
        let LocalSMSDetails = getESPSendSMSDetails();
        let selectedRecord = null;
        let Message = "";
        if (LocalSMSDetails) {
            LocalSMSDetails.map((item) => {
                if (item.nResourceInstanceId === selectedService.nResourceInstanceId) {
                    selectedRecord = item;
                }
            });
        }

        let balanceSMS = 0;
        let isForAdmin = history.location.pathname.includes("/home/spled-service-requests");
        if (selectedService.custrefSRState != "Cancelled" && selectedService.custrefSRState != "Delivered" && selectedService.custrefSRState != "Payment Received" && !isForAdmin) {
            if (selectedService.custrefSRState === "Partial/ Full Payment Pending" && selectedService.user_sms_count.willing_count < selectedService.user_sms_count.willing_count_limit) {
                balanceSMS = selectedService.user_sms_count.willing_count_limit - (selectedService.user_sms_count.willing_count + 1);
                if (selectedRecord && selectedRecord.SMSType === "Willing" && getMinutesBetweenDates(new Date(), new Date(selectedRecord.AddedOn)) < 5) {
                    Message = "You have recently sent an SMS at " +
                        moment(moment.utc(selectedRecord.AddedOn).toDate()).format("MMM Do YYYY, h:mm:ss a") +
                        ". Do you really wish to send a consecutive SMS?  Your balance SMS will be: " + balanceSMS;
                }
                else {
                    Message = "Do you really want to send an SMS?  Your balance SMS will be: " + balanceSMS
                }

                setSendSMSConfirmationMessage(Message)
                toggleSendSMSConfirmationModal();

            }
            else if (selectedService.custrefSRState != "Partial/ Full Payment Pending" && selectedService.user_sms_count.not_willing_count < selectedService.user_sms_count.not_willing_count_limit) {
                balanceSMS = selectedService.user_sms_count.not_willing_count_limit - (selectedService.user_sms_count.not_willing_count + 1);
                if (selectedRecord && selectedRecord.SMSType === "NotWilling" && getMinutesBetweenDates(new Date(), new Date(selectedRecord.AddedOn)) < 5) {
                    Message = "You have recently sent an SMS at " +
                        moment(moment.utc(selectedRecord.AddedOn).toDate()).format("MMM Do YYYY, h:mm:ss a") +
                        ". Do you really wish to send a consecutive SMS?  Your balance SMS will be: " + balanceSMS;
                }
                else {
                    Message = "Do you really want to send an SMS?  Your balance SMS will be: " + balanceSMS
                }
                setSendSMSConfirmationMessage(Message)
                toggleSendSMSConfirmationModal();
            }
            else {
                toast("SMS limit for this service request has been reached.", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }
        }
    };

    const getMinutesBetweenDates = (currentDate, pastDate) => {
        var dif = (currentDate - pastDate);
        var dif = Math.round((dif / 1000) / 60);
        return dif;
    }

    const handleSendSMS = async () => {
        toggleSendSMSConfirmationModal();
        sendFollowupSMS(selectedServiceForSendSMS);


    };

    const sendFollowupSMS = async (selectedService) => {
        try {
            let SMSType = "Willing";
            const payload = {
                nResourceInstanceId: selectedService.nResourceInstanceId,
                sSRState: selectedService.custrefSRState,
            };

            if (selectedService.custrefSRState === "Partial/ Full Payment Pending") {
                SMSType = "Willing";
            }
            else {
                SMSType = "NotWilling";
            }

            setIsLoading(true);
            const { data: _ignore_ } = await api
                .sendFollowupSMS(payload)
                .then((d) => {
                    if (d.data) {
                        setIsLoading(false);
                        if (d.status == 200) {
                            let LocalSMSDetails = getESPSendSMSDetails();
                            if (LocalSMSDetails) {
                                let isUpdated = false;
                                let updated = LocalSMSDetails.map((item) => {
                                    if (item.nResourceInstanceId === selectedService.nResourceInstanceId) {
                                        item.SMSType = SMSType;
                                        item.AddedOn = new Date();
                                        isUpdated = true;
                                    }
                                    return item;
                                });

                                if (isUpdated) {
                                    storeESPSendSMSDetails(updated);
                                }
                                else {
                                    LocalSMSDetails.push({ nResourceInstanceId: selectedService.nResourceInstanceId, SMSType: SMSType, AddedOn: new Date() });
                                    storeESPSendSMSDetails(LocalSMSDetails);
                                }
                            }
                            else {
                                storeESPSendSMSDetails([{ nResourceInstanceId: selectedService.nResourceInstanceId, SMSType: SMSType, AddedOn: new Date() }])
                            }

                            if (d.data.message) {
                                toast(d.data.message, {
                                    autoClose: 5000,
                                    type: toast.TYPE.SUCCESS,
                                });
                            }
                            else {
                                toast("SMS sent successfully.", {
                                    autoClose: 5000,
                                    type: toast.TYPE.SUCCESS,
                                });
                            }
                        }
                        else {
                            if (d.data.message) {
                                toast(d.data.message, {
                                    autoClose: 5000,
                                    type: toast.TYPE.ERROR,
                                });
                            }
                            else {
                                toast("SMS limit for this service request has been reached.", {
                                    autoClose: 5000,
                                    type: toast.TYPE.ERROR,
                                });
                            }
                        }

                        //setSelectedServiceForEdit();
                        //setSelectedSecondServiceForEdit();  
                        getExternalPartnerServices(tableInstance);
                    }
                    else {
                        if (d.status == 204) {
                            toast("SMS limit for this service request has been reached.", {
                                autoClose: 5000,
                                type: toast.TYPE.ERROR,
                            });
                        }
                        else {
                            toast("SMS limit for this service request has been reached.", {
                                autoClose: 5000,
                                type: toast.TYPE.ERROR,
                            });
                        }
                        setSelectedServiceForEdit();
                        setSelectedSecondServiceForEdit();
                        getExternalPartnerServices(tableInstance);
                    }
                })
                .catch((error) => {
                    setIsLoading(false);
                    toast(String(error.response.data.message), {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                });
        }
        catch (error) {
            setIsLoading(false);
        }
    };

    const onTabChanged = async (selectedTab) => {
        setCurrentActiveTab(selectedTab);
    };

    /*const refreshTable = () => {
        toggleShowTable(false);
        //setTimeout(() => toggleShowTable(true), 0.5);
      };*/

    const onFollowUpSave = async (e, service) => {
        if (!FollowUpDate) {
            toast(`Please select follow up date.`, {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
            return;
        }

        let payload = {
            dtFollowupOn: FollowUpDate,
            bHandled: isFollowUpCompleted ? true : null,
            nResourceInstanceId: service.nResourceInstanceId
        }
        AddFollowUp(payload);
    };

    const AddFollowUp = async (payload) => {
        try {
            setIsLoading(true);
            const { data: _ignore_ } = await api
                .updateSPFollowUpData(payload)
                .then((d) => {
                    if (d.data) {
                        setIsLoading(false);
                        toast("Follow up added successfully.", {
                            autoClose: 5000,
                            type: toast.TYPE.SUCCESS,
                        });
                        //setSelectedServiceForEdit();
                        //setSelectedSecondServiceForEdit(); 
                        setFollowUpDate("");
                        setisFollowUpCompleted(false);
                        setisFollowUpOpen(false);
                        getExternalPartnerServices(tableInstance);
                    }
                })
                .catch((error) => {
                    setIsLoading(false);
                    toast(String(error.response.data.detail), {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                });
        }
        catch (error) {
            setIsLoading(false);
        }
    };






    // Offline meet options

    const onOfflineMeetOptionChange = (option, service) => {
        if (option) {
            const updated = {
                ...selectedServiceForEdit,
                custbOfflineMeet: option.value,
            };
            setSelectedServiceForEdit(updated);
        }
        else {
            const updated = {
                ...selectedServiceForEdit,
                custbOfflineMeet: null
            };
            setSelectedServiceForEdit(updated);
        }
    };


    //Offline meet options
    const [offlinemeetoptions, setofflinemeetoptions] = useState([
        {
            value: true,
            label: "Opted",
        },
        {
            value: false,
            label: "Not Opted",
        },
    ]);
    // const [
    // 	selectedofflinemeetoptions,
    // 	setselectedofflinemeetoptions,
    // ] = useState( {
    // 	value: false,
    // 	label: "Not Opted",
    // });
    //End


    const [offlinemeetoptionsForFilter, setofflinemeetoptionsForFilter] = useState([
        // {
        //     value: "all",
        //     label: "All",
        // },
        // {
        //     value: "-1",
        //     label: "Blank",
        // },
        {
            value: false,
            label: "Not Opted",
        },
        {
            value: true,
            label: "Opted",
        },
    ]);
    const [selectedofflinemeetoptionsForFilter, setselectedofflinemeetoptionsForFilter] = useState(null/*{
    value: "all",
    label: "All",
}*/);

    // //offline meet api//
    // const onUpdateOfflineMeetoptions = async () => {		
    //     let bOfflineMeet=selectedofflinemeetoptions.value;	
    //     const { nResourceInstanceId } = selectedServiceForEdit;
    //     api.updateOfflineMeet(nResourceInstanceId,{bOfflineMeet})
    //     .then((response) => {
    //         if (response.status == 202)
    //         {
    //             setSelectedServiceForEdit({...selectedServiceForEdit,bOfflineMeet:bOfflineMeet})
    //             if(response.data.message)
    //             {
    //                 toast(response.data.message, {
    //                     autoClose: 5000,
    //                     type: toast.TYPE.SUCCESS,
    //                 });
    //             }
    //             else
    //             {
    //                 toast("Service updated successfully.", {
    //                     autoClose: 5000,
    //                     type: toast.TYPE.SUCCESS,
    //                 });
    //             }
    //         }
    //         else
    //         {
    //             if(response.data.message)
    //             {
    //                 toast(response.data.message, {
    //                     autoClose: 5000,
    //                     type: toast.TYPE.ERROR,
    //                 });
    //             }
    //             else
    //             {
    //                 toast("Internal server error.", {
    //                     autoClose: 5000,
    //                     type: toast.TYPE.ERROR,
    //                 });
    //             }
    //         }
    //         //toggleNotesModal();
    //         //getServices(tableInstance);				
    //     })
    //     .catch((error) => {
    //         toast(String(error.response.data.message), {
    //             autoClose: 5000,
    //             type: toast.TYPE.ERROR,
    //         });
    //     });	
    // };
    // //End



    const [showRefundModal, setRefundModalVisibility] = useState(false);
    const [refundDetails, setRefundDetails] = useState({});
    const [isLoadingRefund, setIsLoadingRefund] = useState(false);
    const [selectedCancellationReasonForRefund, setSelectedCancellationReasonForRefund] = useState();
    const [enableOtherDescriptionTextboxForRefund, setEnableOtherDescriptionTextboxForRefund] = useState(false);
    const [cancellationReasonOtherDescriptionforRefund, setCancellationReasonOtherDescriptionforRefund] = useState();
    const [selectedServiceRequest, setSelectedServiceRequest] = useState();
    const [refundModal, setRefundModal] = useState(false)
    const [selectedService, setSelectedService] = useState();


    const toggleRefundModal = (e) => {
        let user = getUser();
        if (e && e["refFacilitator"]) {
            if (
                user.access_rights["SERVICE"] &&
                user.access_rights["SERVICE"].includes("MANAGE") == false
            ) {
                toast(`You are not a facilitator.`, {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
                return;
            }
            if (user.email !== e["refFacilitator"]["email"]) {
                toast("You are not the assigned facilitator.", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
                return;
            }
            if (e["dtRefunded"]) {
                var dtrefund = new Date(e["dtRefunded"]);
            }

            setRefundDetails({
                bRefund: e["bRefund"],
                sRefundComment: e["sRefundComment"],
                dtRefunded: dtrefund,
            });
            setSelectedServiceForEdit(e);
        }
        setRefundModalVisibility(!showRefundModal);
    };

    const onRefundDetailsChanged = (name, value) => {
        const updated = { ...refundDetails, [name]: value };

        setRefundDetails(updated);
    };

    const onSaveRefundDetails = async () => {
        const {
            bRefund,
            sRefundComment,
            dtRefunded,
        } = refundDetails;

        if (bRefund) {
            if (!dtRefunded) {
                toast("Refund date is required", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
                return;
            }

            if (!sRefundComment) {
                toast("Refund comment is required", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
                return;
            }

            let sServiceCancellationReason = null, sServiceCancellationReasonOtherDescription = null;
            if (selectedServiceForEdit["refCurrentState"]["sServiceState"] !== "Cancelled") {
                if (selectedCancellationReasonForRefund) {
                    sServiceCancellationReason = selectedCancellationReasonForRefund.value;
                    if (sServiceCancellationReason !== "Other") {
                        sServiceCancellationReasonOtherDescription = null;
                    }
                    else {
                        if (cancellationReasonOtherDescriptionforRefund) {
                            sServiceCancellationReasonOtherDescription = cancellationReasonOtherDescriptionforRefund;
                        }
                        else {
                            toast("Please specify cancellation reason.", {
                                autoClose: 5000,
                                type: toast.TYPE.ERROR,
                            });
                            return;
                        }
                    }
                }
                else {
                    toast("Please select cancellation reason.", {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                    return;
                }
            }
            setIsLoadingRefund(true);
            const { nResourceInstanceId } = selectedServiceForEdit;
            api.saveRefundDetails({
                bRefund,
                sRefundComment,
                dtRefunded: dtRefunded.toISOString(),
                nResourceInstanceId,
                sServiceCancellationReason,
                sServiceCancellationReasonOtherDescription
            })
                .then((response) => {

                    if (response.status == 202) {
                        if (response.data.message) {
                            toast(response.data.message, {
                                autoClose: 5000,
                                type: toast.TYPE.SUCCESS,
                            });
                        }
                        else {
                            toast("Service updated successfully.", {
                                autoClose: 5000,
                                type: toast.TYPE.SUCCESS,
                            });
                        }
                    }
                    else {
                        if (response.data.message) {
                            toast(response.data.message, {
                                autoClose: 5000,
                                type: toast.TYPE.ERROR,
                            });
                        }
                        else {
                            toast("Internal server error.", {
                                autoClose: 5000,
                                type: toast.TYPE.ERROR,
                            });
                        }
                    }

                    // getServices(tableInstance);
                    // updateStatusArray(nResourceInstanceId);
                    // toggleRefundModal();
                    setIsLoadingRefund(false);
                    openRefundModalIsFalse()
                })
                .catch((error) => {
                    toast(String(error.response.data.message), {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                    setIsLoadingRefund(false);
                });
        }
        else {
            toast("Please select is Refunded.", {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
            return;
        }
    };

    useEffect(() => {
        setSelectedCancellationReasonForRefund();
        setCancellationReasonOtherDescriptionforRefund();
        if (selectedServiceForEdit && cancellationReasonDropdownOptions) {
            let temp = cancellationReasonDropdownOptions.map((e) => {
                if (e.value === selectedServiceForEdit.sServiceCancellationReason) {
                    setSelectedCancellationReasonForRefund(e);
                    if (e.value === "Other") {
                        setCancellationReasonOtherDescriptionforRefund(
                            selectedServiceForEdit.sServiceCancellationReasonOtherDescription
                        );
                    }
                }
            });
        }

    }, [selectedServiceForEdit, selectedService]);

    const calculateEnableOtherDescriptionTextboxForRefund = () => {
        if (
            selectedCancellationReasonForRefund &&
            selectedCancellationReasonForRefund.value === "Other"
        )
            setEnableOtherDescriptionTextboxForRefund(true);
        else setEnableOtherDescriptionTextboxForRefund(false);
    };

    useEffect(() => {
        calculateEnableOtherDescriptionTextboxForRefund();
    }, [selectedCancellationReasonForRefund]);

    const openRefundModalIsTrue = () => {
        setRefundModal(true)
    }

    const openRefundModalIsFalse = () => {
        setRefundModal(false)
    }

    const checkNotes = (instanceId, serviceNameListESP) => {

        if (instanceId) {
            api.getESPNotesLogByServiceId({ nResourceInstanceId: instanceId })
                .then((d) => {
                    let data = d.data;
                    const checkCondition = hasNoShowNote(data)
                    setSelectedNoShowEligible(checkCondition)
                });
        }
    }

    const hasNoShowNote = (notesArray) => {
        return notesArray.some(note =>
            note.sNotes && note.sNotes.toLowerCase().includes("no show")
        );
    }

    const serviceAutoRefresh = (instance, flag = false) => {
        if (!instance) return;
        if (!tableInstance) setTableInstance(instance);
        if (history.location.pathname.includes("/home/spled-service-requests")) {
            if (!selectedExternalServicePartner) return;
        }

        const { page } = instance.state ?? { page: 0 };
        let icurrentPage = page;
        if (!flag && isNaN(icurrentPage)) return;
        const pageSize = selectedPageSizeOption.value;

        // if (flag || isNaN(icurrentPage)) {
        //     icurrentPage = 0;
        // }

        if (icurrentPage != currentPage) {
            setExpandedChange({});
        }

        //let sortParams = null;
        //if (instance.state.sorted.length > 0) {
        //const { id, desc } = instance.state.sorted[0];
        //sortParams = { column: id, desc };
        //}

        let serviceRequestListtemp2 = [];
        selectedServiceNameListForFilter.map((e) => {
            if (e.value != "*") {
                serviceRequestListtemp2.push(e.value);
            }
        });
        const serviceRequestList = serviceRequestListtemp2;

        let servicestatusListtemp2 = [];
        selectedServiceStatusListForFilter.map((e) => {
            if (e.value != "*") {
                servicestatusListtemp2.push(e.value);
            }
        });
        const serviceStatusList = servicestatusListtemp2;

        let serviceStatusFilter = [];
        serviceStatusList.map((e) => {
            if (e === "Willing to Pay") {
                serviceStatusFilter.push("Ready For Progression:Partner");
                serviceStatusFilter.push("Partial/ Full Payment Pending");
            }
            else if (e === "Payment Received") {
                serviceStatusFilter.push("Payment Confirmed By Partner");
                serviceStatusFilter.push("Ready For Progression:deAsra");
            }
            else {
                serviceStatusFilter.push(e);
            }
        });
        const statusList = serviceStatusFilter;

        let ResourceNamesTemp = []
        selectedOppTitle.map((e) => {
            if (e.value != "*") {
                ResourceNamesTemp.push(e.value)
            }
        })

        let filterParameters = {
            page_no: icurrentPage + 1,
            page_size: pageSize
            //...sortParams,
        };

        if (serviceRequestList.length) {
            filterParameters.service_codes = serviceRequestList;
        }
        if (statusList.length) {
            filterParameters.statusList = statusList;
        }

        if (selectedRequestedaCallBackOption && selectedRequestedaCallBackOption.value == 'yes') {
            filterParameters.bRequestedCallBack = true;
        }
        else if (selectedRequestedaCallBackOption && selectedRequestedaCallBackOption.value == 'no') {
            filterParameters.bRequestedCallBack = false;
        }

        if (selectedCallStatusOptionForFilter && selectedCallStatusOptionForFilter.value != 'all') {
            filterParameters.sCallStatus = selectedCallStatusOptionForFilter.value;
        }


        if (selectedofflinemeetoptionsForFilter && selectedofflinemeetoptionsForFilter.value != 'all') {
            filterParameters.bOfflineMeet = selectedofflinemeetoptionsForFilter.value;
        }

        if (selectedOppType) {
            filterParameters.service_codes = [selectedOppType.value]
        }

        if (selectedOppTitle) {
            filterParameters.ResourceName = ResourceNamesTemp
        }

        if (confirmationChecked) {
            filterParameters.bConfirmation_tag = confirmationChecked
        }

        if (selectedBusinessSector.length > 0) {
            filterParameters.sBusinessSector = processFilters(selectedBusinessSector)
        }

        if (selectedBusinessCity.length > 0) {
            filterParameters.sBusinessCity = processFilters(selectedBusinessCity)
        }

        if (selectedJpmcEligible) {
            filterParameters.JPMC_eligible = selectedJpmcEligible.value
        }
        if (selectedNoShow) {
            filterParameters.bNoShow = selectedNoShow.value
        }

        if (selectedNeedToTalkToSPOption && selectedNeedToTalkToSPOption.value == 'yes') {
            filterParameters.bNeedToTalkToSP = true;
        }
        else if (selectedNeedToTalkToSPOption && selectedNeedToTalkToSPOption.value == 'no') {
            filterParameters.bNeedToTalkToSP = false;
        }

        if (selectedRequestedByOption && selectedRequestedByOption.value == 'ehh') {
            filterParameters.req_by = 'ehh';
        }
        else if (selectedRequestedByOption && selectedRequestedByOption.value == 'user') {
            filterParameters.req_by = 'user';
        }

        if (searchTerm) {
            filterParameters.search_value = searchTerm;
        }

        if (fromDate) {
            filterParameters.fromDate = fromDate;
        }

        if (toDate) {
            filterParameters.toDate = adjustedToDate(toDate);;
        }

        if (history.location.pathname.includes("/home/spled-service-requests") && selectedExternalServicePartner) {
            filterParameters.email = selectedExternalServicePartner.value;
        }

        if (selectedPackageNameListForFilter) {
            filterParameters.nPackageCatalogueId = selectedPackageNameListForFilter.value;
        }

        if (requestWithinTAT) {
            if (requestWithinTAT === "yes") {
                filterParameters.within_tat = "True";
            }
            else {
                filterParameters.within_tat = "False";
            }
        }
        const { tempServices } = api.getExternalPartnerServices(filterParameters).then(({ data }) => {
            if (data) {
                setcurrentPage(icurrentPage);
                setPages(data.total_pages);
                setPageSize(pageSize);
                setDisplayRecordCount({ ...displayRecordCount, count: data?.total_count })
                setUnReadFeedbackCount(data.unread_feedbacks);
                setFollowUpCount(data.todays_follow_up_count || 0);
                setAllFollowUpCount(data.all_follow_up_count || 0)
                let tempLPMServiceList = data.ServiceRequests.map((x) => {
                    x.custrefSRState = x.refSRState;
                    x.custsSRCancellationReason = x.sSRCancellationReason;
                    x.custssSRCancellationReasonOtherDescription = x.sSRCancellationReasonOtherDescription;
                    x.custsNotesHH = null;
                    x.custdtFollowupOn = null;
                    x.custsFollowupNotes = null;
                    x.serviceFrom = "LPM";
                    x.custOtherServiceInfo = x.sOtherServicesInfo;
                    x.custfGovtCharges = x.ext_sp_charges ? (x.ext_sp_charges.fGovtCharges) : (null);
                    x.custfAffiliateFees = x.ext_sp_charges ? (x.ext_sp_charges.fAffiliateFees) : (null);
                    x.custfProfessionalCharges = x.ext_sp_charges ? (x.ext_sp_charges.fProfessionalCharges) : (null);
                    x.custfTotalCharges = x.ext_sp_charges ? (x.ext_sp_charges.fTotalCharges) : (null);
                    x.custChargesid = x.ext_sp_charges ? (x.ext_sp_charges.id) : (null);
                    x.custsCallStatus = x.sCallStatus;
                    x.custsUpdateNoteForAllServicesInPackage = false;
                    x.custbNeedToTalkToSP = x.bNeedToTalkToSP;
                    x.custbOfflineMeet = x.bOfflineMeet;
                    return x;
                });

                let tempSPMerviceList = data.Services.map((x) => {
                    x.custrefSRState = x.refCurrentState.sServiceState;
                    x.custsSRCancellationReason = x.sServiceCancellationReason;
                    x.custssSRCancellationReasonOtherDescription = x.sServiceCancellationReasonOtherDescription;
                    x.custsNotesHH = null;
                    x.custdtFollowupOn = null;
                    x.custsFollowupNotes = null;
                    x.serviceFrom = "SPM";
                    x.OtherServiceInfo = null;
                    x.custOtherServiceInfo = x.sOtherServicesInfo;
                    x.custfGovtCharges = x.ext_sp_charges ? (x.ext_sp_charges.fGovtCharges) : (null);
                    x.custfAffiliateFees = x.ext_sp_charges ? (x.ext_sp_charges.fAffiliateFees) : (null);
                    x.custfProfessionalCharges = x.ext_sp_charges ? (x.ext_sp_charges.fProfessionalCharges) : (null);
                    x.custfTotalCharges = x.ext_sp_charges ? (x.ext_sp_charges.fTotalCharges) : (null);
                    x.custChargesid = x.ext_sp_charges ? (x.ext_sp_charges.id) : (null);
                    x.custsCallStatus = x.sCallStatus;
                    x.custsUpdateNoteForAllServicesInPackage = false;
                    x.custbNeedToTalkToSP = x.bNeedToTalkToSP;
                    x.custbOfflineMeet = x.bOfflineMeet;
                    return x;
                });

                var masterAllServiceRequests = [...tempLPMServiceList, ...tempSPMerviceList];
                let sortedServiceRequestsDesc = masterAllServiceRequests.sort((a, b) => {
                    return parseInt(b.nResourceInstanceId) - parseInt(a.nResourceInstanceId);
                })
                setEditingServiceRequestList(sortedServiceRequestsDesc);
            }
            else {
                toast("", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }
        }).catch((error) => {
            // setIsLoading(false);


        });
    }

    useEffect(() => {
        if (!editingServiceRequestList) return;

        if (selectedServiceForEdit?.nResourceInstanceId) return;

        const interval = setInterval(() => {
            serviceAutoRefresh(tableInstance, true)
        }, 30000);

        return () => {
            clearInterval(interval);
        };
    }, [editingServiceRequestList, selectedServiceForEdit?.nResourceInstanceId]);

    return (
        <>
            {
                activePage === "SPLedServiceRequests" ?
                    (
                        currentActiveTab === "Service Requests" ?
                            (
                                <div className={`spled-container ${isLoading && "set-opacity"}`}>
                                    {isLoading && <Spinner className="center-screen" />}
                                    {
                                        <ESPServiceRequestGrid
                                            data={editingServiceRequestList}
                                            openConfirmationModalisTrue={openConfirmationModalisTrue}
                                            selectedServiceForEdit={selectedServiceForEdit}
                                            ServiceRequestsStatesOptions={masterServiceRequestStates}
                                            onServiceRequestsStateChange={(option, service) => {
                                                //setSelectedMovedToSPMStatus(option);
                                                //var option1=service;
                                                //data[0].refSRState=option.value;
                                                //setEditingServiceRequestList(data);
                                                onServiceRequestsStateChange(option, service)
                                            }}
                                            jpmcEligibleOption={jpmcEligibleOption}
                                            onJpmcEligileOptionChange={onJpmcEligileOptionChange}
                                            selectedJpmcEligible={selectedJpmcEligible}
                                            setSelectedJpmcEligible={setSelectedJpmcEligible}
                                            noShowOption={noShowOption}
                                            selectedNoShow={selectedNoShow}
                                            onNoShowChange={onNoShowChange}
                                            checkNotes={checkNotes}
                                            handleNoShow={handleNoShow}
                                            selectedNoShowEligible={selectedNoShowEligible}
                                            setIsLoading={setIsLoading}
                                            cancellationReasonDropdownOptions={cancellationReasonDropdownOptions}
                                            onCancellationReasonChange={(option, service) => {
                                                //setSelectedMovedToSPMStatus(option);
                                                //var option1=service;
                                                //data[0].sSRCancellationReason=option.value;
                                                onCancellationReasonChange(option, service);
                                            }}
                                            onRowDoubleClick={onRowDoubleClick}
                                            onRowCancelEdit={onRowCancelEdit}
                                            handleServiceRequestsNotesChange={handleServiceRequestsNotesChange}
                                            activeFocus={activeFocus}
                                            onRowSave={onRowSave}
                                            customerNeedAnyOtherServiceOptions={customerNeedAnyOtherServiceOptions}
                                            onustomerNeedAnyOtherServiceOptionChange={(option, service) => {
                                                onustomerNeedAnyOtherServiceOptionChange(option, service);
                                            }}
                                            onFetchServiceRequests={fetchServiceRequests}
                                            pages={pages}
                                            displayRecordCount={displayRecordCount}
                                            pageSize={pageSize}
                                            page={currentPage}
                                            changePage={changePage}
                                            toggleRefundModal={openRefundModalIsTrue}
                                            //For Filter by service
                                            toggleAllForFilter={toggleAllForFilter}
                                            toggleSelectionForFilter={toggleSelectionForFilter}
                                            serviceNameListForFilter={serviceNameListForFilter}
                                            selectedServiceNameListForFilter={selectedServiceNameListForFilter}
                                            onSearchClicked={handleSearchClick}
                                            onClearFilterSearch={handleClearFilterSearch}
                                            serviceStatusList={serviceStatusList}
                                            toggleServiceStatus={toggleServiceStatus}
                                            fromDate={fromDate}
                                            toDate={toDate}
                                            setfromDate={setfromDate}
                                            settoDate={settoDate}
                                            requestedaCallBackOptions={requestedaCallBackOptions}
                                            selectedRequestedaCallBackOption={selectedRequestedaCallBackOption}
                                            selectedNeedToTalkToSPOption={selectedNeedToTalkToSPOption}
                                            requestedByOptions={requestedByOptions}
                                            selectedRequestedByOption={selectedRequestedByOption}
                                            setSelectedRequestedaCallBackOption={(option) => { setSelectedRequestedaCallBackOption(option); }}
                                            setSelectedNeedToTalkToSPOption={(option) => { setSelectedNeedToTalkToSPOption(option); }}
                                            setSelectedRequestedByOption={(option) => { setSelectedRequestedByOption(option); }}
                                            onSearchInputChange={handleSearchInputChange}
                                            searchTerm={searchTerm}
                                            packageNameListForFilter={packageNameListForFilter}
                                            oppTypeNameListForFilter={oppTypeNameListForFilter}
                                            selectedPackageNameListForFilter={selectedPackageNameListForFilter}
                                            setSelectedPackageNameListForFilter={(option) => { setSelectedPackageNameListForFilter(option); }}
                                            //End Filter by service
                                            handleReportsClick={handleReportsClick}
                                            callStatusOptions={callStatusOptions}
                                            onCallStatusOptionChange={(option, service) => {
                                                onCallStatusOptionChange(option, service);
                                            }}
                                            callStatusOptionsForFilter={callStatusOptionsForFilter}
                                            selectedCallStatusOptionForFilter={selectedCallStatusOptionForFilter}
                                            setselectedCallStatusOptionForFilter={(option) => { setselectedCallStatusOptionForFilter(option); }}
                                            showTable={showTable}
                                            pageSizeOptions={pageSizeOptions}
                                            selectedPageSizeOption={selectedPageSizeOption}
                                            onPageSizeOptionChange={(option) => {
                                                setSelectedPageSizeOption(option);
                                                //setPageSize(option.value);
                                                //getExternalPartnerServices(tableInstance,true);
                                            }}
                                            UpdateNewNotesFlag={(nResourceInstanceId) => { UpdateNewNotesFlag(nResourceInstanceId); }}
                                            handleCursorPositionChange={handleCursorPositionChange}
                                            custsNotesHHCursorPosition={custsNotesHHCursorPosition}
                                            onToggledePrenuerListingModal={onToggledePrenuerListingModal}
                                            onEditdePrenuerListringDetails={onEditdePrenuerListringDetails}
                                            onToggleVerifyBusinessModal={onToggleVerifyBusinessModal}

                                            ExpandedChange={ExpandedChange}
                                            setExpandedChange={setExpandedChange}

                                            showFilterModal={showFilterModal}
                                            toggleFilterModal={toggleFilterModal}
                                            handleViewFilterModal={handleViewFilterModal}
                                            toggleAllForServiceStatusFilter={toggleAllForServiceStatusFilter}
                                            toggleSelectionForServiceStatusFilter={toggleSelectionForServiceStatusFilter}
                                            selectedServiceStatusListForFilter={selectedServiceStatusListForFilter}
                                            serviceStatusNameListForFilter={serviceStatusNameListForFilter}
                                            handleSendSMSClick={handleSendSMSClick}
                                            onTabChanged={onTabChanged}
                                            unReadFeedbackCount={unReadFeedbackCount}

                                            //dePreneue listing details modal
                                            showdePreneurDetailsModal={showdePreneurDetailsModal}
                                            toggledePreneurDetailsModal={toggledePreneurDetailsModal}
                                            handleViewdePreneurDetailsModal={handleViewdePreneurDetailsModal}
                                            selectedServiceRequestBusinessDetails={selectedServiceRequestBusinessDetails}
                                            selectedServiceRequestBusinessDetailsForEdit={selectedServiceRequestBusinessDetailsForEdit}
                                            onBusinessDetailsChange={onBusinessDetailsChange}
                                            onBusinessDetailsUpdate={onBusinessDetailsUpdate}
                                            onBusinessVerifyUpdate={onBusinessVerifyUpdate}
                                            ondePreneurDetailsUpdate={ondePreneurDetailsUpdate}

                                            //For Admin
                                            externalServicePartnerOptions={externalServicePartnerList}
                                            selectedExternalServicePartner={selectedExternalServicePartner}
                                            onExternalServicePartnerChange={(option) => { onExternalServicePartnerChange(option); }}
                                            ExternalServicePartnerOrganization={selectedExternalServicePartnerOrganization}
                                            isForAdmin={history.location.pathname.includes("/home/spled-service-requests")}

                                            needToTalkToSPOptions={needToTalkToSPOptions}
                                            onNeedToTalkToSPOptionChange={(option, service) => {
                                                onNeedToTalkToSPOptionChange(option, service);
                                            }}

                                            isFollowUpOpen={isFollowUpOpen}
                                            handleFollowUpClick={handleFollowUpClick}
                                            FollowUpDate={FollowUpDate}
                                            setFollowUpDate={setFollowUpDate}
                                            isFollowUpCompleted={isFollowUpCompleted}
                                            setisFollowUpCompleted={setisFollowUpCompleted}
                                            onFollowUpSave={onFollowUpSave}
                                            FollowUpCount={FollowUpCount}
                                            onFollowUpsCountClick={onFollowUpsCountClick}
                                            AllFollowUpCount={AllFollowUpCount}


                                            //offline meet
                                            //selectedofflinemeetoptions={selectedofflinemeetoptions}
                                            //setselectedofflinemeetoptions={(option) => {setselectedofflinemeetoptions(option);}}
                                            offlinemeetoptions={offlinemeetoptions}
                                            onOfflineMeetOptionChange={(option, service) => {
                                                onOfflineMeetOptionChange(option, service);
                                            }}
                                            offlinemeetoptionsForFilter={offlinemeetoptionsForFilter}
                                            selectedofflinemeetoptionsForFilter={selectedofflinemeetoptionsForFilter}
                                            setselectedofflinemeetoptionsForFilter={(option) => { setselectedofflinemeetoptionsForFilter(option); }}
                                            getExternalPartnerServices={() => getExternalPartnerServices(tableInstance, false)}
                                            oppTypeNameList={oppTypeNameList}
                                            selectedOppType={selectedOppType}
                                            onOppTypeChange={onOppTypeChange}
                                            onFilterSearchClick={onFilterSearchClick}

                                            oppTitleNameList={oppTitleNameList}
                                            selectedOppTitle={selectedOppTitle}
                                            onOppTitleChange={onOppTitleChange}
                                            toggleAllOppTitle={toggleAllOppTitle}

                                            confirmationChecked={confirmationChecked}
                                            setConfirmationChecked={setConfirmationChecked}

                                            businessSectorList={businessSectorList}
                                            onBusinessSectorChange={onBusinessSectorChange}
                                            selectedBusinessSector={selectedBusinessSector}
                                            toggleAllSector={toggleAllSector}

                                            businessCityList={businessCityList}
                                            selectedBusinessCity={selectedBusinessCity}
                                            onBusinessCityChange={onBusinessCityChange}
                                            toggleAllBusinessCity={toggleAllBusinessCity}
                                        // offlinemeetoptions={offlinemeetoptions}
                                        // selectedofflinemeetoptions={selectedofflinemeetoptions}
                                        // setselectedofflinemeetoptions={setselectedofflinemeetoptions}
                                        // onUpdateOfflineMeetoptions={onUpdateOfflineMeetoptions}
                                        />
                                        /*):
                                        ("")*/
                                    }

                                    {/* Confirmation Modal */}

                                    <Modal isOpen={confirmationModal} style={{ zIndex: 1 }}>
                                        <ModalContent className="confirmation-modal-small">
                                            <div className="modal-header" style={{
                                                backgroundColor: '#76287C',
                                                color: '#fff'
                                            }}>
                                                <span className="modal-title">Confirm</span>
                                                <img
                                                    alt="close"
                                                    id="Close"
                                                    src={close_modal}
                                                    className="close modal-close"
                                                    onClick={openConfirmationModalisFalse}
                                                />
                                            </div>

                                            <div className="modal-body">
                                                Are you sure you want to perform this action? Price is set to 0(zero) and this cannot be changed later.
                                                <div className="row">
                                                    <div className="col-12 d-flex align-items-center" style={{
                                                        justifyContent: 'flex-end'
                                                    }}>
                                                        <button
                                                            type="button"
                                                            className="my-services-model-submit-btn conv-mr25"
                                                            onClick={confirmBtnClick}
                                                        >
                                                            Yes
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="my-services-model-cancel-btn conv-mr25"
                                                            onClick={() => {
                                                                openConfirmationModalisFalse()
                                                            }}
                                                        >
                                                            No
                                                        </button>
                                                    </div>

                                                </div>
                                            </div>
                                        </ModalContent>
                                    </Modal>

                                    <Modal isOpen={refundModal}>
                                        <ModalContent className="refund-modal">
                                            <div className="p-2 modal-headers-bar">
                                                <span>Refund Details</span>
                                                <img
                                                    alt="close"
                                                    id="Close"
                                                    src={close_modal}
                                                    className="close modal-close"
                                                    onClick={openRefundModalIsFalse}
                                                />
                                            </div>

                                            <div className="modal-body">
                                                <div className='form-group'>
                                                    <div className='row'>
                                                        <div className="col-md-12">
                                                            <div style={{ float: "left", marginTop: "4px" }}>
                                                                <Checkbox
                                                                    id="Refund"
                                                                    checked={refundDetails.bRefund || false}
                                                                    onChange={(e) => {
                                                                        e.stopPropagation();
                                                                        onRefundDetailsChanged(
                                                                            "bRefund",
                                                                            !refundDetails.bRefund
                                                                        );
                                                                    }}
                                                                    label=" Is Refunded"
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                    }}
                                                                />
                                                            </div>

                                                            <span>Refund date:</span>
                                                            <ReactDatePicker
                                                                dateFormat="dd/MM/yyyy"
                                                                selected={refundDetails.dtRefunded || ""}
                                                                onChange={(date) =>
                                                                    onRefundDetailsChanged("dtRefunded", date)
                                                                }
                                                                maxDate={new Date()}
                                                                style={{ width: "30px" }}
                                                            />
                                                        </div>


                                                    </div>
                                                    <span>Refund comment:</span>
                                                    <div className="form-group">
                                                        {/*<ControlledInput
							name="sRefundComment"
							label="Refund comment:"
							value={refundDetails.sRefundComment || ""}
							onChange={({ target: { name, value } }) =>
								props.onInputChange(name, value)
							}
							onClick={(e) => {
								e.stopPropagation();
							}}
						// required
						/>*/}
                                                        <textarea
                                                            name="sRefundComment"
                                                            label="Refund comment:"
                                                            className="w-100 form-control rounded"
                                                            value={refundDetails.sRefundComment || ""}
                                                            onChange={({ target: { name, value } }) =>
                                                                onRefundDetailsChanged(name, value)
                                                            }
                                                            style={{ minHeight: "95px" }}
                                                        />
                                                    </div>

                                                    <span>Cancellation reason:</span>
                                                    <Select
                                                        // className={`mb-2   ${
                                                        // 	selectedServiceRequest.custrefSRState!="Cancelled"
                                                        // 		? "disabled"
                                                        // 		: ""
                                                        // }`}
                                                        // className="mb-2"
                                                        options={cancellationReasonDropdownOptions}
                                                        onChange={setSelectedCancellationReasonForRefund}
                                                        value={selectedCancellationReasonForRefund}
                                                        isClearable
                                                    // isDisabled=	{
                                                    //     selectedServiceRequest.custrefSRState!="Cancelled" ?
                                                    // 				true:false
                                                    // 			}
                                                    />

                                                    {enableOtherDescriptionTextboxForRefund ? (
                                                        <ControlledInput
                                                            // className={
                                                            // 	props.service["refCurrentState"]["sServiceState"] === "Cancelled"
                                                            // 		? "disabled"
                                                            // 		: ""
                                                            // }
                                                            placeholder="Please specify a reason here"
                                                            // onChange={(event) => { event.persist();debounce(() => {props.onSearchInputChange(event)},1000)}}
                                                            onChange={({ target }) =>
                                                                setCancellationReasonOtherDescriptionforRefund(
                                                                    target.value
                                                                )}
                                                            value={cancellationReasonOtherDescriptionforRefund}
                                                        // isDisabled=	{
                                                        // 	props.service["refCurrentState"]["sServiceState"] === "Cancelled"?
                                                        // 	true:false
                                                        // }
                                                        />
                                                    ) : (
                                                        <>
                                                        </>
                                                    )}


                                                    <div className="mt-4">
                                                        <Button
                                                            id="spmRefundSave"
                                                            onClick={onSaveRefundDetails}
                                                        >
                                                            Save Refund
                                                        </Button>
                                                        <span
                                                            id="spmRefundCancel"
                                                            className="ml-2 cursor-pointer"
                                                            onClick={openRefundModalIsFalse}
                                                        >
                                                            Cancel
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>

                                        </ModalContent>
                                    </Modal>

                                    <ConfirmationModalSmall
                                        message="Your unsaved changes will be lost, do you want to continue?"
                                        isOpen={showConfirmationModal}
                                        toggleModal={toggleConfirmationModal}
                                        onPositive={onSelectSecondService}
                                    />
                                    <ConfirmationModalSmall
                                        message={SendSMSConfirmationMessage}
                                        isOpen={showSendSMSConfirmationModal}
                                        toggleModal={toggleSendSMSConfirmationModal}
                                        onPositive={handleSendSMS}
                                        buttonText={"Yes"}
                                    />
                                    <ESPReportsModal
                                        isOpen={showReportsModal}
                                        isLoadingReports={isLoadingReports}
                                        toggleModal={toggleReportsModal}
                                        ASPfromDate={ASPfromDate}
                                        ASPtoDate={ASPtoDate}
                                        SRFfromDate={SRFfromDate}
                                        SRFtoDate={SRFtoDate}
                                        setASPfromDate={setASPfromDate}
                                        setASPtoDate={setASPtoDate}
                                        setSRFfromDate={setSRFfromDate}
                                        setSRFtoDate={setSRFtoDate}
                                        fetchFullfillmentReport={fetchFullfillmentReport}
                                        fetchAllServicesReport={fetchAllServicesReport}
                                        fetchSMSTrailReport={fetchSMSTrailReport}
                                    />

                                    <DePrenuerListingDetailsModal
                                        isOpen={showdePrenuerListringDetailsModal}
                                        toggleModal={onToggledePrenuerListingModal}
                                        selectedServiceRequestBusinessDetails={selectedServiceRequestBusinessDetails}
                                    />

                                    <EditDeprenuerListingDetailsModal
                                        isOpen={showEditdePrenuerListringDetailsModal}
                                        toggleModal={onEditdePrenuerListringDetails}
                                        selectedServiceRequestBusinessDetails={selectedServiceRequestBusinessDetails}
                                        onBusinessDetailsChange={onBusinessDetailsChange}
                                        onBusinessDetailsUpdate={onBusinessDetailsUpdate}
                                    />

                                    <MarkVerifiedBusinessModel
                                        isOpen={showVerifyBusinessModal}
                                        toggleModal={onToggleVerifyBusinessModal}
                                        selectedServiceRequestBusinessDetails={selectedServiceRequestBusinessDetails}
                                        onBusinessDetailsChange={onBusinessDetailsChange}
                                        onBusinessVerifyUpdate={onBusinessVerifyUpdate}
                                    />
                                    {/* <button onClick={() => {
                                        openRefundModalIsTrue()
                                    }}>Hello</button> */}
                                </div>
                            )
                            :
                            (
                                <CustomerFeedbackContainer
                                    onTabChanged={onTabChanged}
                                    responseType={responseType}
                                    fromDate={FfromDate}
                                    toDate={FtoDate}
                                    selectedExternalServicePartner={selectedExternalServicePartner}
                                    isForAdmin={history.location.pathname.includes("/home/spled-service-requests")}
                                />
                            )
                    ) :
                    activePage === "No_Access" ?
                        (
                            <div className={`row row-container`}>
                                <div className="col-12 row-margin-10px" style={{ textAlign: "center" }}>
                                    <label>
                                        <b>You are not allowed to access this page, Please contact admin for more details.</b>
                                    </label>
                                </div>
                            </div>
                        )
                        :
                        (
                            ""
                        )
            }

        </>
    );
}